import React, { useState, useEffect, useContext } from 'react'
import axios from 'axios'
import { Link } from 'react-router-dom'
import { CopyToClipboard } from 'react-copy-to-clipboard';
import '../ProposalView/ProposalView.css'
//make sure to comment out MediaQueries until completed.
import './MediaQueries.css'
import BarChart from '../Charts/BarChart'
import OffsetChart from '../Charts/OffsetChart'
import YearAvgChart from '../Charts/YearAvgChart'
import DoughnutChart from '../Charts/DoughnutChart'
import MosaicCredit from '../Mosaic/MosaicCredit'
import UpdateCustomer from './UpdateCustomer'
import { UserContext } from '../../UserContext'

import Alert from 'react-s-alert'
import CircularProgress from '@material-ui/core/CircularProgress';
import MenuRoundedIcon from '@material-ui/icons/MenuRounded';
import Button from '@material-ui/core/Button';
import AddRoundedIcon from '@material-ui/icons/AddRounded';
import AttachMoneyRoundedIcon from '@material-ui/icons/AttachMoneyRounded';
import FlashOnRoundedIcon from '@material-ui/icons/FlashOnRounded';
import ViewModuleRoundedIcon from '@material-ui/icons/ViewModuleRounded';
import MenuItem from '@material-ui/core/MenuItem';
import Menu from '@material-ui/core/Menu';
import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Switch from '@material-ui/core/Switch';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import InputLabel from '@material-ui/core/InputLabel';
import TextField from '@material-ui/core/TextField';
import InputAdornment from '@material-ui/core/InputAdornment';
import CheckCircleOutlineRoundedIcon from '@material-ui/icons/CheckCircleOutlineRounded';
import MailOutlineRoundedIcon from '@material-ui/icons/MailOutlineRounded';
import AssignmentOutlinedIcon from '@material-ui/icons/AssignmentOutlined';

import CheckBoxOutlineBlankOutlinedIcon from '@material-ui/icons/CheckBoxOutlineBlankOutlined';
import CheckBoxOutlinedIcon from '@material-ui/icons/CheckBoxOutlined';
import ListAltRoundedIcon from '@material-ui/icons/ListAltRounded';
import EqualizerRoundedIcon from '@material-ui/icons/EqualizerRounded';
import SaveRoundedIcon from '@material-ui/icons/SaveRounded';
import ArrowUpwardRoundedIcon from '@material-ui/icons/ArrowUpwardRounded';
import ArrowDownwardRoundedIcon from '@material-ui/icons/ArrowDownwardRounded';
import SettingsInputComponentRoundedIcon from '@material-ui/icons/SettingsInputComponentRounded';
import SyncRoundedIcon from '@material-ui/icons/SyncRounded';
import ExpandMoreRoundedIcon from '@material-ui/icons/ExpandMoreRounded';
import LinkRoundedIcon from '@material-ui/icons/LinkRounded';
import GetAppRoundedIcon from '@material-ui/icons/GetAppRounded';
import DeleteIcon from '@material-ui/icons/Delete';
import IconButton from '@material-ui/core/IconButton';
import BorderColorRoundedIcon from '@material-ui/icons/BorderColorRounded';
import DataUsageIcon from '@material-ui/icons/DataUsage';

import MasterCalc from '../UsageFunctions/MasterCalc'
import PNMCalc from '../UsageFunctions/PNMCalc'
import BlackHillsCalc from '../UsageFunctions/BlackHillsCalc'
import OverRideCalc from '../UsageFunctions/OverRideCalc'
import ColoradoUsage from '../UsageFunctions/ColoradoUsage'
import UtahUsage from '../UsageFunctions/UtahUsage'
import WyomingUsage from '../UsageFunctions/WyomingUsage'
import NevadaUsage from '../UsageFunctions/NevadaUsage'
import VirginiaUsage from '../UsageFunctions/VirginiaUsage'
import OregonUsage from '../UsageFunctions/OregonUsage'
import TexasUsage from '../UsageFunctions/TexasUsage'
import NewMexicoUsage from '../UsageFunctions/NewMexicoUsage'
import NorthCarolinaUsage from '../UsageFunctions/NorthCarolinaUsage'
import SouthCarolinaUsage from '../UsageFunctions/SouthCarolinaUsage'
import FloridaUsage from '../UsageFunctions/FloridaUsage'
// import MappedLoans1 from './MappedLoans1'
// import MappedLoans2 from './MappedLoans2'

import Title from '../Title/Title'
import moment from 'moment'
import { isFlow } from '@babel/types';


const ProposalView = (props) => {

  const { activeUser, setActiveUser } = useContext(UserContext);

  const [user, setUser] = useState();

  // console.log(activeUser)


  const [proposal, setProposal] = useState([])
  const [proposals, setProposals] = useState([])
  const [utility, setUtility] = useState('')
  const [monthlyUsage, setMonthlyUsage] = useState('')
  const [customer, setCustomer] = useState([])

  const [janProduction, setJanProduction] = useState('')
  const [febProduction, setFebProduction] = useState('')
  const [marProduction, setMarProduction] = useState('')
  const [aprProduction, setAprProduction] = useState('')
  const [mayProduction, setMayProduction] = useState('')
  const [junProduction, setJunProduction] = useState('')
  const [julyProduction, setJulyProduction] = useState('')
  const [augProduction, setAugProduction] = useState('')
  const [sepProduction, setSepProduction] = useState('')
  const [octProduction, setOctProduction] = useState('')
  const [novProduction, setNovProduction] = useState('')
  const [decProduction, setDecProduction] = useState('')

  const [panelAmount, setPanelAmount] = useState('')
  const [originalPanelAmount, setOriginalPanelAmount] = useState('')
  const [systemSize, setSystemSize] = useState('')
  // const [arrayCount, setArrayCount] = useState('')
  const [systemCost, setSystemCost] = useState('')
  const [totalProduction, setTotalProduction] = useState('')
  const [loanAmount, setLoanAmount] = useState('')
  const [rebate, setRebate] = useState('')
  const [partialPanels, setPartialPanels] = useState('')
  const [stateTax, setStateTax] = useState(0)
  const [pRatio] = useState('')
  const [mod, setMod] = useState('')
  const [modules, setModules] = useState([])
  const [inverters, setInverters] = useState([])
  const [uType, setUType] = useState('')
  const [design, setDesign] = useState('')
  const [calcUtility, setCalcUtility] = useState('')
  const [annualUsage, setAnnualUsage] = useState('')
  const [squareFootage, setSquareFootage] = useState('')

  const [adders, setAdders] = useState([])
  const [currentProp, setCurrentProp] = useState('')

  const [viewEquipment, setViewEquipment] = useState(false)
  const [viewAdders, setViewAdders] = useState(false)
  const [viewProposals, setViewProposals] = useState(false)
  const [viewLoans, setViewLoans] = useState(false)
  const [viewCustomer, setViewCustomer] = useState(false)
  const [viewCiaInfo, setViewCiaInfo] = useState(false)
  const [viewNest, setViewNest] = useState(false)
  const [addNestPanel, setAddNestPanel] = useState(1)


  const [rebateSF, setRebateSF] = useState('')
  const [cpsRebate, setCpsRebate] = useState(0)
  const [austinRebate, setAustinRebate] = useState(0)
  const [timeStamp, setTimeStamp] = useState('')
  const [copied, setCopied] = useState(false)

  //adders
  const [adderTotal, setAdderTotal] = useState('')
  const [treeRemoval, setTreeRemoval] = useState(0)
  const [treeRemovalAmount, setTreeRemovalAmount] = useState('')
  const [reRoof, setReRoof] = useState(0)
  const [reRoofAmount, setReRoofAmount] = useState('')
  const [smartHome, setSmartHome] = useState(0)
  const [smartHomeAmount, setSmartHomeAmount] = useState('')
  const [hvac, setHvac] = useState(0)
  const [hvacAmount, setHvacAmount] = useState('')
  const [led, setLed] = useState(0)
  const [ledAmount, setLedAmount] = useState('')
  const [turf, setTurf] = useState(0)
  const [turfAmount, setTurfAmount] = useState('')
  const [windows, setWindows] = useState(0)
  const [windowsAmount, setWindowsAmount] = useState('')
  const [water, setWater] = useState(0)
  const [waterAmount, setWaterAmount] = useState('')
  const [travel, setTravel] = useState(0)
  const [travelAmount, setTravelAmount] = useState('')
  const [ballast, setBallast] = useState(0)
  const [ballastAmount, setBallastAmount] = useState(.20)
  const [ballastPanels, setBallastPanels] = useState('')
  const [ballastTotal, setBallastTotal] = useState('')
  const [pSolar, setPSolar] = useState(0)
  const [pSolarAmount, setPSolarAmount] = useState(.15)
  const [groundMount, setGroundMount] = useState(0)
  const [groundMountAmount, setGroundMountAmount] = useState(1.30)
  const [groundMountPanels, setGroundMountPanels] = useState('')
  const [groundMountTotal, setGroundMountTotal] = useState('')
  const [msp, setMsp] = useState(0)
  const [mspAmount, setMspAmount] = useState(1500)
  const [critterGuard, setCritterGuard] = useState(0)
  const [critterGuardAmount, setCritterGuardAmount] = useState(0.10)
  const [military, setMilitary] = useState(0)
  const [miscCash, setMiscCash] = useState(0)
  const [miscCashAmount, setMiscCashAmount] = useState('')
  const [miscCashNotes, setMiscCashNotes] = useState('')
  const [blackFriday, setBlackFriday] = useState(0)
  const [battery3, setBattery3] = useState(0)
  const [battery3Amount] = useState(9204)
  const [battery10, setBattery10] = useState(0)
  const [battery10Amount, setBattery10Amount] = useState(17250)
  const [ppw, setPpw] = useState('')
  const [cashPpw, setCashPpw] = useState('')
  const [basePpw, setBasePpw] = useState('')
  // const [commission, setCommission] = useState('')
  const [overRide] = useState(false)
  const [ionRebate, setIonRebate] = useState(0)
  const [ionRebate2, setIonRebate2] = useState('')
  const [slcAdder, setSlcAdder] = useState('')
  const [slcAdderAmount, setSlcAdderAmount] = useState(600)
  const [nest, setNest] = useState('')
  const [nestAmount, setNestAmount] = useState(2076)
  const [nestMax, setNestMax] = useState(.05)
  const [adderAmount, setAdderAmount] = useState(600)
  const [adderAmount2, setAdderAmount2] = useState(1200)
  const [dealerFee] = useState(.74) // File is not used
  const [highLoan, setHighLoan] = useState(0)
  // const [highLoanProp, setHighLoanProp] = useState(0)
  const [preferredUtility, setPreferredUtility] = useState(0)
  const [preferredUtilityAmount, setPreferredUtilityAmount] = useState(.40)
  const [sameDay, setSameDay] = useState(0)
  const [sameDayAmount, setSameDayAmount] = useState(1000)
  const [referral, setReferral] = useState(0)
  const [referralAmount, setReferralAmount] = useState(1500)
  const [nestAdder, setNestAdder] = useState(0)
  const [nestAdderAmount, setNestAdderAmount] = useState(100)
  const [calculation, setCalculation] = useState('')
  const [sustainable, setSustainable] = useState(0)
  const [sustainableAmount, setSustainableAmount] = useState(200)

  // console.log(preferredUtility)

  const [loanProducts, setLoanProducts] = useState([])
  const [loanProducts2, setLoanProducts2] = useState([])

  // const [setterAmount] = useState(.20)

  const [loanA, setLoanA] = useState('')
  const [loanB, setLoanB] = useState([])
  const [loanADefault, setLoanADefault] = useState([])
  const [utilityId, setUtilityId] = useState('')
  const [inverterId, setInverterId] = useState('')
  const [hasRebate, setHasRebate] = useState('')
  const [rebateOverride, setRebateOverride] = useState('')
  const [salesTeam, setSalesTeam] = useState('')
  const [team, setTeam] = useState('')
  const [teamPpw, setTeamPpw] = useState('')
  const [updateCustomer, setUpdateCustomer] = useState(false)
  const [qualify, setQualify] = useState(false)
  const [bundleId, setBundleId] = useState('')
  const [disclosures, setDisclosures] = useState([])

  const [loading, setLoading] = useState(false)
  const [ciaLoading, setCiaLoading] = useState(false)
  const [syncLoading, setSyncLoading] = useState(false)
  const [agree, setAgree] = useState(false)
  const [agreed, setAgreed] = useState(false)

  const view = props.match.params.view

  // console.log(salesTeam)

  const getProposal = () => {
    axios.post(`https://dev.iondeveloper.com/api/proposal/proposal-tool/?api_key=${process.env.REACT_APP_API_KEY}`, { method: 'get_proposal', prop_id: props.match.params.prop_id }).then((res) => {
      // console.log(res.data)
      const { jan, feb, mar, apr, may, june, july, aug, sept, oct, nov, december, modCount, ogModCount, systemSize, ballast, ballastModules, groundMount, msp, pSolar, travel, critterGuard, battery3, battery10, id1, loan1, term1, int1, pre1, post1, interest1, id2, specialPrice1, loan2, term2, int2, pre2, post2, interest2, specialPrice2, ionRebate, ionRebate2, arrayCount, hasNest, propDesign, travelAmount, treeTrim, treeTrimAmount, reroof, reroofAmount, itc1, itc2, utility, rebateOverride, modId, utilityPpw, ppw, module, modModel, modSize, modPtcRating, utilityId, invId, hasRebate, sameDay, preferredUtility, referral, hasNestAdder, rebatePanels, groundMountModules, teamPpw, sustainable, smartHome, smartHomeAmount, hvac, hvacAmount, led, ledAmount, turf, turfAmount, windows, windowsAmount, water, waterAmount, military, miscCash, miscCashAmount, miscCashNotes, blackFriday, ballastAmount, critterGuardAmount, mspAmount, pSolarAmount, battery10Amount, groundMountAmount } = res.data.data
      let rOverride = hasRebate
      if (+rebateOverride > 1) {
        rOverride = rebateOverride
      }
      return [setLoanA([+id1, loan1, +term1, +int1, +pre1, +post1, +interest1, +itc1, +specialPrice1]), setLoanADefault([+id1, loan1, +term1, +int1, +pre1, +post1, +interest1, +itc1]), setMod([modId, module, modModel, modSize, modPtcRating]), setNest(+hasNest), setLoanB([+id2, loan2, +term2, +int2, +pre2, +post2, +interest2, +itc2
      ]), setProposal(res.data.data), setPpw(+ppw), setBasePpw(+utilityPpw), setJanProduction(+jan), setFebProduction(+feb), setMarProduction(+mar), setAprProduction(+apr), setMayProduction(+may), setJunProduction(+june), setJulyProduction(+july), setAugProduction(+aug), setSepProduction(+sept), setOctProduction(+oct), setNovProduction(+nov), setDecProduction(+december), setPanelAmount(+modCount), setOriginalPanelAmount(+ogModCount), setBallast(+ballast), setGroundMount(+groundMount), setMsp(+msp), setPSolar(+pSolar), setTravel(+travel), setTravelAmount(+travelAmount), setTreeRemoval(+treeTrim), setTreeRemovalAmount(+treeTrimAmount), setReRoof(+reroof), setReRoofAmount(+reroofAmount), setCritterGuard(+critterGuard), setBattery3(+battery3), setBattery10(+battery10), setIonRebate(+ionRebate), setIonRebate2(+ionRebate2), setDesign(propDesign), setCalcUtility(utility), setBallastPanels(+ballastModules), setUtilityId(utilityId), setInverterId(invId), setSameDay(+sameDay), setPreferredUtility(+preferredUtility), setReferral(+referral), setNestAdder(+hasNestAdder), setCalculation(res.data.calc), setPartialPanels(+rebatePanels), setTeamPpw(+teamPpw), setSustainable(+sustainable), setSmartHome(+smartHome), setSmartHomeAmount(+smartHomeAmount), setHvac(+hvac), setHvacAmount(+hvacAmount), setLed(+led), setLedAmount(+ledAmount), setTurf(+turf), setTurfAmount(+turfAmount), setWindows(+windows), setWindowsAmount(+windowsAmount), setWater(+water), setWaterAmount(+waterAmount), setMilitary(+military), setMiscCash(+miscCash), setMiscCashAmount(+miscCashAmount), setMiscCashNotes(miscCashNotes), setBlackFriday(+blackFriday), setRebateOverride(rebateOverride), setHasRebate(rOverride)]
    })
  }

  useEffect(() => {
    if (+view === 1) {
      setUser(`${activeUser.attributes.given_name} ${activeUser.attributes.family_name}`)
    }
  }, [])

  useEffect(() => {
    if (+proposal.ballastAmount > 0) {
      setBallastAmount(+proposal.ballastAmount)
    }
    if (+proposal.critterGuardAmount > 0) {
      setCritterGuardAmount(+proposal.critterGuardAmount)
    }
    if (+proposal.mspAmount > 0) {
      setMspAmount(+proposal.mspAmount)
    }
    if (+proposal.pSolarAmount > 0) {
      setPSolarAmount(+proposal.pSolarAmount)
    }
    if (+proposal.battery10Amount > 0) {
      setBattery10Amount(+proposal.battery10Amount)
    }
    if (+proposal.groundMountAmount > 0) {
      setGroundMountAmount(+proposal.groundMountAmount)
    }
  }, [proposal])

  if (originalPanelAmount === 0) {
    setOriginalPanelAmount(panelAmount)
  }

  let sharedHome = 0
  if (customer.designType === 'MultiFamily/Shared Roofs') {
    sharedHome = 1
  }

  // console.log(sharedHome)



  const createSignedProposal = () => {
    axios.post(`https://dev.iondeveloper.com/api/proposal/proposal-tool/?api_key=${process.env.REACT_APP_API_KEY}`, { method: 'create_proposal', project_id: proposal.projectId, prop_size: systemSize, mod_count: panelAmount, og_mod_count: originalPanelAmount, max_mod_count: maxModCount, inv_count: panelAmount, total_system_cost: systemCost, prop_loan_amount: loanAmount, down_payment: downPayment, has_nest: nest, rebate_amount: rebate, rebate_in_sf: rebateSF, rebate_override: proposal.rebateOverride, rebate_panels: partialPanels, array_count: arrayCount, prop_ppw: ppw, cost_override: costOverRide, prop_design: design, ballast: ballast, ballast_amount: ballastAmount, ballast_panels: ballastPanels, ground_mount: groundMount, ground_mount_amount: groundMountAmount, ground_mount_panels: groundMountPanels, p_solar: pSolar, p_solar_amount: pSolarAmount, travel: travel, travel_amount: travelAmount, tree_trim: treeRemoval, trim_amount: treeRemovalAmount, reroof: reRoof, reroof_amount: reRoofAmount, ion_rebate: ionRebate, ion_rebate2: ionRebate2, msp: msp, msp_amount: mspAmount, critter_guard: critterGuard, critter_guard_amount: critterGuardAmount, battery3: battery3, battery10: battery10, battery10_amount: battery10Amount, rate_override: rateOverRide, rate_amount: rateAmount, jan: janProduction, feb: febProduction, mar: marProduction, apr: aprProduction, may: mayProduction, june: junProduction, july: julyProduction, aug: augProduction, sept: sepProduction, oct: octProduction, nov: novProduction, december: decProduction, prop_ratio: propRatio, mod_id: mod[0], inv_id: inverterId, utility_id: utilityId, loan_id1: loanA[0], loan_id2: loanB[0], time_stamp: timeStamp, rep_gen: 1, cost_25_yr: cost25yr, curr_ann_bill: currAnnBill, today: today, yr_5: yr5, yr_10: yr10, yr_15: yr15, yr_20: yr20, yr_25: yr25, gallon: gallon, home: home, garbage: garbage, tree: tree, display_prod: +displayProd, nest_impact: nestImpact, utility_power: utilityPower, solar_power: solarPower, jan_u: janU, feb_u: febU, mar_u: marU, apr_u: aprU, may_u: mayU, jun_u: junU, july_u: julyU, aug_u: augU, sep_u: sepU, oct_u: octU, nov_u: novU, dec_u: decU, jan_p: janP, feb_p: febP, mar_p: marP, apr_p: aprP, may_p: maP, jun_p: junP, july_p: julP, aug_p: augP, sep_p: sepP, oct_p: octP, nov_p: novP, dec_p: decP, pmt_1: pmt1, pmt_2: pmt2, pmt_3: pmt3, state_tax: stateTax, net_cost: netCost, itc_total: itcTotal, all_incentives: allIncentives, avg_25_utility: avg25Utility, avg_25_1: avg25_1, avg_25_2: avg25_2, pmt_1_b: pmt1B, pmt_2_b: pmt2B, loan_1_savings: loan1Savings, loan_2_savings: loan2Savings, ion_cost_a: ionCostA, ion_cost_b: ionCostB, remaining_cost: remainingCost, current_per_kw: currentPerKw, same_day: sameDay, preferred_utility: preferredUtility, referral: referral, has_nest_adder: nestAdder, team_ppw: teamPpw, sustainable: sustainable, smart_home: smartHome, smart_home_amt: smartHomeAmount, hvac: hvac, hvac_amt: hvacAmount, led: led, led_amt: ledAmount, turf: turf, turf_amt: turfAmount, windows: windows, windows_amt: windowsAmount, water: water, water_amt: waterAmount, military: military, misc_cash: miscCash, misc_cash_amount: miscCashAmount, black_friday: blackFriday, adder_total: adderTotal, sharedHome: sharedHome, user: user })
      .then((res) => {
        Alert.success(`${systemSize / 1000}kW Proposal Created`, {
          position: 'top-right',
          effect: 'flip',
          beep: false,
          timeout: 5000,
          offset: 100,
          color: 'rgba(255, 255, 255, 0.927)'
        })
        // console.log(res);
        getProposalsByProjectId()
        getCustomer()
        setLoading(false)
        setSyncLoading(false)
      })
  }
  const createProposal = () => {
    axios.post(`https://dev.iondeveloper.com/api/proposal/proposal-tool/?api_key=${process.env.REACT_APP_API_KEY}`, { method: 'create_proposal_rep_test', project_id: proposal.projectId, prop_size: systemSize, mod_count: panelAmount, og_mod_count: originalPanelAmount, max_mod_count: maxModCount, inv_count: panelAmount, total_system_cost: systemCost, prop_loan_amount: loanAmount, down_payment: downPayment, has_nest: nest, rebate_amount: rebate, rebate_in_sf: rebateSF, rebate_override: rebateOverride, rebate_panels: partialPanels, array_count: arrayCount, prop_ppw: ppw, cost_override: costOverRide, prop_design: design, ballast: ballast, ballast_amount: ballastAmount, ballast_panels: ballastPanels, ground_mount: groundMount, ground_mount_amount: groundMountAmount, ground_mount_panels: groundMountPanels, p_solar: pSolar, p_solar_amount: pSolarAmount, travel: travel, travel_amount: travelAmount, tree_trim: treeRemoval, trim_amount: treeRemovalAmount, reroof: reRoof, reroof_amount: reRoofAmount, ion_rebate: ionRebate, ion_rebate2: ionRebate2, msp: msp, msp_amount: mspAmount, critter_guard: critterGuard, critter_guard_amount: critterGuardAmount, battery3: battery3, battery10: battery10, battery10_amount: battery10Amount, rate_override: rateOverRide, rate_amount: rateAmount, jan: janProduction, feb: febProduction, mar: marProduction, apr: aprProduction, may: mayProduction, june: junProduction, july: julyProduction, aug: augProduction, sept: sepProduction, oct: octProduction, nov: novProduction, december: decProduction, prop_ratio: propRatio, mod_id: mod[0], inv_id: inverterId, utility_id: utilityId, loan_id1: loanA[0], loan_id2: loanB[0], time_stamp: timeStamp, rep_gen: 1, cost_25_yr: cost25yr, curr_ann_bill: currAnnBill, today: today, yr_5: yr5, yr_10: yr10, yr_15: yr15, yr_20: yr20, yr_25: yr25, gallon: gallon, home: home, garbage: garbage, tree: tree, display_prod: +displayProd, nest_impact: nestImpact, utility_power: utilityPower, solar_power: solarPower, jan_u: janU, feb_u: febU, mar_u: marU, apr_u: aprU, may_u: mayU, jun_u: junU, july_u: julyU, aug_u: augU, sep_u: sepU, oct_u: octU, nov_u: novU, dec_u: decU, jan_p: janP, feb_p: febP, mar_p: marP, apr_p: aprP, may_p: maP, jun_p: junP, july_p: julP, aug_p: augP, sep_p: sepP, oct_p: octP, nov_p: novP, dec_p: decP, pmt_1: pmt1, pmt_2: pmt2, pmt_3: pmt3, state_tax: stateTax, net_cost: netCost, itc_total: itcTotal, all_incentives: allIncentives, avg_25_utility: avg25Utility, avg_25_1: avg25_1, avg_25_2: avg25_2, pmt_1_b: pmt1B, pmt_2_b: pmt2B, loan_1_savings: loan1Savings, loan_2_savings: loan2Savings, ion_cost_a: ionCostA, ion_cost_b: ionCostB, remaining_cost: remainingCost, current_per_kw: currentPerKw, same_day: sameDay, preferred_utility: preferredUtility, referral: referral, has_nest_adder: nestAdder, team_ppw: teamPpw, sustainable: sustainable, smart_home: smartHome, smart_home_amt: smartHomeAmount, hvac: hvac, hvac_amt: hvacAmount, led: led, led_amt: ledAmount, turf: turf, turf_amt: turfAmount, windows: windows, windows_amt: windowsAmount, water: water, water_amt: waterAmount, military: military, misc_cash: miscCash, misc_cash_amount: miscCashAmount, black_friday: blackFriday, adder_total: adderTotal, fId: customer.financeId, dId: customer.designId, iId: customer.installId, surveys: surveys, stories: customer.stories, ids: adderIds, sharedHome: sharedHome, user: user, misc_cash_notes: miscCashNotes })
      .then((res) => {
        Alert.success(`${systemSize / 1000}kW Proposal Created and CIA Updated`, {
          position: 'top-right',
          effect: 'flip',
          beep: false,
          timeout: 5000,
          offset: 100,
          color: 'rgba(255, 255, 255, 0.927)'
        })
        console.log(res);
        getProposalsByProjectId()
        getCustomer()
        setLoading(false)
        setSyncLoading(false)
      })
  }

  const buildNewProposal = () => {
    if (signedProp === true) {
      return createSignedProposal()
    } if (miscCash === 1 && miscCashNotes === '') {
      return Alert.error(`Add notes to the Misc Cash Incentive`, {
        position: 'top-right',
        effect: 'flip',
        beep: false,
        timeout: 5000,
        offset: 100,
        color: 'rgba(255, 255, 255, 0.927)'
      })
    } if (miscCash === 1 && miscCashAmount < 1) {
      return Alert.error(`Add amount to the Misc Cash Incentive`, {
        position: 'top-right',
        effect: 'flip',
        beep: false,
        timeout: 5000,
        offset: 100,
        color: 'rgba(255, 255, 255, 0.927)'
      })
    } return createProposal(),
      setLoading(true),
      setSyncLoading(true)
  }

  let loanSource = loanA[1]
  let loanProduct = `Single ${loanA[2]}yr ${loanA[3]}%`

  if (loanA[1]?.toLowerCase() === 'goodleap') {
    loanSource = 'LoanPal'
  }

  // if (+loanA[3] === 1.39) {
  //   loanProduct = `Single ${loanA[2]}yr 1.49%`
  // }

  // console.log(loanSource)


  const getCustomer = () => {
    axios.post(`https://dev.iondeveloper.com/api/proposal/proposal-tool/?api_key=${process.env.REACT_APP_API_KEY}`, { method: 'get_info', project_id: proposal.projectId }).then((res) => {
      // console.log(res.data)
      return [setCustomer(res.data.data), setUtility(res.data.data.utility), setMonthlyUsage(res.data.usage), setUType(res.data.data.usageType), setSquareFootage(res.data.data.sqFootage), setSalesTeam(res.data.data.salesTeam), setAdders(res.data.adders), setCurrentProp(res.data.proposal), setSyncLoading(false)]

    })
  }

  // useEffect(() => {
  //   if (adders.length > 0) {
  //     for (let i = 0; i < adders.length; i++) {
  //       if (adders[i].name === 'MISC Cash') {
  //         return setMiscCashNotes(adders[i].notes)
  //       }
  //     }
  //   }
  // }, [adders])

  // console.log(miscCashNotes)


  const financingLabel = () => {
    return <span style={{ fontWeight: 'bold' }}>{currentProp.financingSource === 'Owner Financing' ? 'Cash' : 'Loan'} Amount: </span>
  }




  const getSalesTeam = () => {
    axios.post(`https://dev.iondeveloper.com/api/proposal/proposal-tool/?api_key=${process.env.REACT_APP_API_KEY}`, { method: 'get_sales_team_test', sales_team: salesTeam }).then(
      (res) => {
        // console.log(res.data)
        return [setTeam(res.data.data), setCashPpw(+res.data.data.cashPpw), setLoanProducts(res.data.loans), setLoanProducts2(res.data.loans2)]
      }
    )
  }

  let surveyTypes
  if (customer.surveyType) {
    surveyTypes = customer.surveyType.split(';')
  }
  let surveys = []
  if (customer.surveyType) {
    for (let i = 0; i <= surveyTypes.length; i++) {
      if (surveyTypes[i] === 'Roof Measurements Needed') {
        surveys.push(surveyTypes[i])
      }
      if (surveyTypes[i] === 'Suneyes Needed') {
        surveys.push(surveyTypes[i])
      }
    }
  }
  // console.log(salesTeam, basePpw)


  let multiply = (num1, num2) => {
    return num1 * num2
  }

  const getModules = () => {
    axios.post(`https://dev.iondeveloper.com/api/proposal/proposal-tool/?api_key=${process.env.REACT_APP_API_KEY}`, { method: 'get_modules' }).then(
      (res) => {
        // console.log(res.data)
        return setModules(res.data.data)
      }
    )
  }

  const getInverters = () => {
    axios.post(`https://dev.iondeveloper.com/api/proposal/proposal-tool/?api_key=${process.env.REACT_APP_API_KEY}`, { method: 'get_inverters' }).then(
      (res) => {
        // console.log(res.data)
        return setInverters(res.data.data)
      }
    )
  }

  const getProposalsByProjectId = () => {
    axios.post(`https://dev.iondeveloper.com/api/proposal/proposal-tool/?api_key=${process.env.REACT_APP_API_KEY}`, { method: 'get_proposal_by_project_id', project_id: proposal.projectId }).then((res) => {
      // console.log(res.data)
      return setProposals(res.data.data)
    })
  }

  useEffect(() => {
    if (design) {
      setTimeStamp(moment().format('MM/DD/YY, h:mm a'))
    }
  }, [design])

  useEffect(() => {
    getModules()
  }, [])

  useEffect(() => {
    if (proposal?.projectId) {
      getProposalsByProjectId()
    }
  }, [proposal])

  useEffect(() => {
    getInverters()
  }, [])

  // useEffect(() => {
  //   getLoanProducts()
  // }, [])

  useEffect(() => {
    setSystemCost(Math.round(+proposal.loanAmount + +proposal.rebate + +proposal.downPayment))
  }, [proposal])


  useEffect(() => {
    getProposal()
  }, [])

  useEffect(() => {
    if (salesTeam) {
      getSalesTeam()
    }
  }, [salesTeam])

  useEffect(() => {
    if (proposal?.projectId) {
      getCustomer()
    }
  }, [proposal])

  // console.log(proposal, customer)

  useEffect(() => {
    setSystemSize(panelAmount * mod[3])
  }, [panelAmount, mod])



  // const vegasSqFt = () => {
  //   if (squareFootage >= 4000) {
  //     return setAnnualUsage(Math.round(2392.4 * Math.pow(+squareFootage, .25)))
  //   } else if (squareFootage < 4000 && squareFootage > 1000) {
  //     return setAnnualUsage(Math.round(4.286 * +squareFootage + 1882))
  //   } else if (squareFootage <= 1000) {
  //     return setAnnualUsage(Math.round(195.05 * Math.pow(+squareFootage, .5)))
  //   }
  // }

  useEffect(() => {
    if (uType === 'Square Footage') {
      switch (customer.territory) {
        case 'Albuquerque':
          //setAnnualUsage(9503)
          break;
        case 'Colorado Springs':
          //setAnnualUsage(9955)
          break;
        // case 'Las Vegas':
        //   vegasSqFt()
        //   // setAnnualUsage(12771)
        //   break;
        case 'Buda':
          //setAnnualUsage(12479)
          break;
        case 'Denver':
          //setAnnualUsage(10413)
          break;
        case 'Dallas':
          //setAnnualUsage(12236)
          break;
        case 'Las Vegas':
          if (squareFootage >= 4000) {
            //return setAnnualUsage(Math.round(2392.4 * Math.pow(+squareFootage, .25)))
          } else if (squareFootage < 4000 && squareFootage > 1000) {
            //return setAnnualUsage(Math.round(4.286 * +squareFootage + 1882))
          } else if (squareFootage <= 1000) {
            //return setAnnualUsage(Math.round(195.05 * Math.pow(+squareFootage, .5)))
          }
          // setAnnualUsage(12771)
          break;
        case 'Utah':
          //setAnnualUsage(10639)
          break;
        case 'Oregon':
          //setAnnualUsage(9687)
          break;
        case 'North Carolina':
          //setAnnualUsage(13100)
          break;
        case 'South Carolina':
          //setAnnualUsage(13100)
          break;
        case 'Richmond':
          //setAnnualUsage(16126)
          break;
        case 'Virginia Beach':
          //setAnnualUsage(15052)
          break;
        default:
          //setAnnualUsage(12475)
      }

    }
  }, [customer, uType, squareFootage])

  useEffect(() => {
    if (uType === 'Annual' || uType === 'Annual - Square Footage') {
      setAnnualUsage(customer.usage)
    }
  }, [customer, uType])




  const { january, february, march, april, may, june, july, august, september, october, november, december } = monthlyUsage

  const { modSize, rebateType, invRating, modPtcRating, rebatePerWatt, rebateFixed, modId, modModel, rebateMax, module, invType, invModel, modCount, propRatio, downPayment, utilityLocation, rateOverRide, rateAmount, arrayCount, maxModCount, costOverRide, ballastModules, groundMountModules } = proposal

  const { loan3, term3, interest3, post3, pre3, int3, id3, itc3, specialPrice3, specialLoanIncrease, loanChangeSize, loanChangeIncrease, loanOptions } = team

  const { tierType, surcharge, tax, tier1, tier2, tier3, tier4, sTier1, sTier2, sTier3, sTier4, wTier1, wTier2, wTier3, wTier4, tierAmount, sTierAmount, wTierAmount, tier1Amount, tier2Amount, tier3Amount, tier4Amount, sTier1Amount, sTier2Amount, sTier3Amount, sTier4Amount, wTier1Amount, wTier2Amount, wTier3Amount, wTier4Amount } = calculation

  let calcs = [tierType, +surcharge, +tax, +tier1, +tier2, +tier3, +tier4, +sTier1, +sTier2, +sTier3, +sTier4, +wTier1, +wTier2, +wTier3, +wTier4, +tierAmount, +sTierAmount, +wTierAmount, +tier1Amount, +tier2Amount, +tier3Amount, +tier4Amount, +sTier1Amount, +sTier2Amount, +sTier3Amount, +sTier4Amount, +wTier1Amount, +wTier2Amount, +wTier3Amount, +wTier4Amount]

  // console.log(calcs)


  // console.log(loanOptions)
  // console.log(arrayCount)


  let mappedInverters = inverters.map((inv, i) => {
    // console.log(loans.loanTerm)
    return <option key={i} value={inv.invId}> {`${inv.make} ${inv.model}`}</option>
  })



  useEffect(() => {
    if (ballast === 1) {
      return setBallastPanels(+ballastModules)
    } setBallastPanels(+panelAmount)
  }, [proposal, ballastPanels, ballast])

  useEffect(() => {
    if (ballastModules > 0) {
      return setBallastTotal((+ballastPanels * +mod[3]) * +ballastAmount)
    } setBallastTotal(+systemSize * +ballastAmount)
  }, [proposal, ballast, ballastPanels])

  useEffect(() => {
    if (groundMount === 1 && +groundMountModules > 0) {
      return setGroundMountPanels(+groundMountModules)
    } setGroundMountPanels(+panelAmount)
  }, [proposal, groundMountPanels, groundMount, panelAmount])

  useEffect(() => {
    if (+groundMountModules > 0) {
      return setGroundMountTotal((+groundMountPanels * +mod[3]) * +groundMountAmount)
    } setGroundMountTotal(+systemSize * +groundMountAmount)
  }, [proposal, groundMount, groundMountPanels])

  // console.log(groundMountPanels)


  // console.log(groundMount, groundMountPanels, groundMountTotal)

  //loan[0] = loanId
  //loan[1] = loanName
  //loan[2] = term
  //loan[3] = interest
  //loan[4] = prePayment
  //loan[5] = postPayment
  //loan[6] = intOnlyPayment

  //mod[0] = modId
  //mod[1] = module
  //mod[2] = mod_model
  //mod[3] = modSize
  //mod[4] = modPtcRating

  // console.log(module)

  let usage = [+january, +february, +march, +april, +may, +june, +july, +august, +september, +october, +november, +december]
  let usageChart = [+january, +february, +march, +april, +may, +june, +july, +august, +september, +october, +november, +december]
  let currentUsage = [+january, +february, +march, +april, +may, +june, +july, +august, +september, +october, +november, +december]
  let production = [+janProduction, +febProduction, +marProduction, +aprProduction, +mayProduction, +junProduction, +julyProduction, +augProduction, +sepProduction, +octProduction, +novProduction, +decProduction]
  let productionChart = [+janProduction, +febProduction, +marProduction, +aprProduction, +mayProduction, +junProduction, +julyProduction, +augProduction, +sepProduction, +octProduction, +novProduction, +decProduction]

  // console.log(currentUsage)


  let monthNest = nestAmount / 12

  if (nest === 1 || nest > 1) {
    production = production.map(x => x + monthNest)
    usageChart = usageChart.map(x => x - monthNest)
  }

  // console.log(nestAmount)

  let jan = +janProduction / totalProduction
  let feb = +febProduction / totalProduction
  let mar = +marProduction / totalProduction
  let apr = +aprProduction / totalProduction
  let mayP = +mayProduction / totalProduction
  let jun = +junProduction / totalProduction
  let julyP = +julyProduction / totalProduction
  let aug = +augProduction / totalProduction
  let sep = +sepProduction / totalProduction
  let oct = +octProduction / totalProduction
  let nov = +novProduction / totalProduction
  let dec = +decProduction / totalProduction

  if (nest === 1 || nest > 1) {
    jan = +janProduction / (totalProduction - nestAmount)
    feb = +febProduction / (totalProduction - nestAmount)
    mar = +marProduction / (totalProduction - nestAmount)
    apr = +aprProduction / (totalProduction - nestAmount)
    mayP = +mayProduction / (totalProduction - nestAmount)
    jun = +junProduction / (totalProduction - nestAmount)
    julyP = +julyProduction / (totalProduction - nestAmount)
    aug = +augProduction / (totalProduction - nestAmount)
    sep = +sepProduction / (totalProduction - nestAmount)
    oct = +octProduction / (totalProduction - nestAmount)
    nov = +novProduction / (totalProduction - nestAmount)
    dec = +decProduction / (totalProduction - nestAmount)
  }

  let propRatios = [jan, feb, mar, apr, mayP, jun, julyP, aug, sep, oct, nov, dec]

  useEffect(() => {
    setJanProduction(Math.round(multiply(+propRatio, (+systemSize / 1000)) * jan))
  }, [systemSize])

  useEffect(() => {
    setFebProduction(Math.round(multiply(+propRatio, (+systemSize / 1000)) * feb))
  }, [systemSize])

  useEffect(() => {
    setMarProduction(Math.round(multiply(+propRatio, (+systemSize / 1000)) * mar))
  }, [systemSize])

  useEffect(() => {
    setAprProduction(Math.round(multiply(+propRatio, (+systemSize / 1000)) * apr))
  }, [systemSize])

  useEffect(() => {
    setMayProduction(Math.round(multiply(+propRatio, (+systemSize / 1000)) * mayP))
  }, [systemSize])

  useEffect(() => {
    setJunProduction(Math.round(multiply(+propRatio, (+systemSize / 1000)) * jun))
  }, [systemSize])

  useEffect(() => {
    setJulyProduction(Math.round(multiply(+propRatio, (+systemSize / 1000)) * julyP))
  }, [systemSize])

  useEffect(() => {
    setAugProduction(Math.round(multiply(+propRatio, (+systemSize / 1000)) * aug))
  }, [systemSize])

  useEffect(() => {
    setSepProduction(Math.round(multiply(+propRatio, (+systemSize / 1000)) * sep))
  }, [systemSize])

  useEffect(() => {
    setOctProduction(Math.round(multiply(+propRatio, (+systemSize / 1000)) * oct))
  }, [systemSize])

  useEffect(() => {
    setNovProduction(Math.round(multiply(+propRatio, (+systemSize / 1000)) * nov))
  }, [systemSize])

  useEffect(() => {
    setDecProduction(Math.round(multiply(+propRatio, (+systemSize / 1000)) * dec))
  }, [systemSize])


  const total = (arr) => arr.reduce((a, b) => a + b)

  useEffect(() => {
    if (utilityLocation === 'Utah') {
      return setStateTax(800)
    }
  }, [proposal])

  useEffect(() => {
    if (utilityLocation === 'New Mexico') {
      let tax = (systemCost - homeEnergyTotal) * .10
      // console.log(tax)
      if (tax >= 6000) {
        return setStateTax(6000)
      } setStateTax(Math.round(tax))
    }
    if (utilityLocation === 'South Carolina') {
      let tax = (systemCost - homeEnergyTotal) * .25
      // console.log(tax)
      if (tax >= 8750) {
        return setStateTax(8750)
      } setStateTax(Math.round(tax))
    }
  }, [props.loan, panelAmount, systemCost, systemSize])

  // useEffect(() => {
  //   if (nest === 2) {
  //     return setNestMax(.05)
  //   }
  //   if (nest === 1) {
  //     return setNestMax(.1)
  //   }
  // }, [nest])

  // console.log(nestMax, nest, nestAmount)




  useEffect(() => {
    if ((billCalc[2] * nestMax) < 2076) {
      setNestAmount(billCalc[2] * nestMax)
    }
  }, [production, nest])

  useEffect(() => {
    if (nest === 0) {
      setNestAdder(0)
    }
  }, [nest])

  // console.log(nestMax, nest, nestAmount)

  useEffect(() => {
    setTotalProduction(total(production))
  }, [production, nest])

  const { name, street, state, city, zip, phone } = customer

  // useEffect(() => {
  //   if (systemSize < 10000) {
  //     setGroundMountAmount(.85)
  //   }
  //   if (systemSize >= 10000) {
  //     setGroundMountAmount(.80)
  //   }
  // }, [panelAmount, systemSize])

  // console.log(groundMountAmount)


  // console.log(utilityLocation, state)
  let newUsage;

  switch (utilityLocation) {
    case 'Colorado':
      newUsage = ColoradoUsage(usage, annualUsage)
      break;
    case 'Utah':
    case 'Idaho':
      newUsage = UtahUsage(usage, annualUsage)
      break;
    case 'Wyoming':
      newUsage = WyomingUsage(usage, annualUsage)
      break;
    case 'Nevada':
      newUsage = NevadaUsage(usage, annualUsage)
      break;
    case 'Virginia':
      newUsage = VirginiaUsage(usage, annualUsage)
      break;
    case 'Oregon':
      newUsage = OregonUsage(usage, annualUsage)
      break;
    case 'Texas':
      newUsage = TexasUsage(usage, annualUsage)
      break;
    case 'New Mexico':
      newUsage = NewMexicoUsage(usage, annualUsage)
      break;
    case 'North Carolina':
      newUsage = NorthCarolinaUsage(usage, annualUsage)
      break;
    case 'South Carolina':
      newUsage = SouthCarolinaUsage(usage, annualUsage)
      break;
    default:
      newUsage = monthlyUsage
  }





  let totalUsage;
  if (newUsage) {
    usage = newUsage
    totalUsage = total(newUsage)
  }


  let newBill = []
  for (let i = 0; i <= production.length - 1; i++) {
    newBill.push(usage[i] - production[i])
  }


  let custUtility = calcUtility
  let billCalc;
  let postBill;



  if (rateOverRide === '0') {
    switch (custUtility) {
      case 'PNM - Public Service Company of New Mexico':
      case 'Continental Divide Electric':
      case 'CNM':
        billCalc = PNMCalc(usage)
        postBill = PNMCalc(newBill)
        break;
      case 'Black Hills Electric':
        billCalc = BlackHillsCalc(usage)
        postBill = BlackHillsCalc(newBill)
        break;
      default:
        billCalc = MasterCalc(usage, calcs)
        postBill = MasterCalc(newBill, calcs)
    }
  } else {
    billCalc = OverRideCalc(usage, rateAmount)
    postBill = OverRideCalc(newBill, rateAmount)
  }
  // console.log(nest, nestMax, nestAmount, (billCalc[2] * nestMax))

  // console.log(postBill)
  useEffect(() => {
    let pu = 0
    let sd = 0
    let ref = 0
    if (sameDay === 1) {
      sd = +sameDayAmount
    }
    if (preferredUtility === 1) {
      pu = +preferredUtilityAmount
    }
    if (referral === 1) {
      ref = +referralAmount
    }
    if (custUtility === 'Austin Energy' || custUtility === 'City of Fort Collins Utilities (FCU)') {
      return setLoanAmount(Math.round(systemCost - downPayment - sd - ref - (systemSize * pu)))
    }
    if (custUtility === 'Salem Electric') {
      if (hasRebate > 1) {
        return setLoanAmount(Math.round(systemCost - rebate - downPayment - sd - ref - (systemSize * pu)))
      }
      return setLoanAmount(Math.round(systemCost - downPayment - sd - ref - (systemSize * pu)))
    }
    setLoanAmount(Math.round(systemCost - rebate - downPayment - sd - ref - (systemSize * pu)))
  }, [panelAmount, systemCost, rebate, custUtility])

  useEffect(() => {
    if (custUtility === 'City Public Service (CPS)' && +proposal.rebate > 0) {
      setCpsRebate(1)
    }
    if (custUtility === 'Austin Energy' && +proposal.rebate > 0 && +proposal.rebateOverride === 0) {
      setAustinRebate(1)
    }
  }, [proposal.rebate, custUtility])

  useEffect(() => {
    if (proposal.rebatePanels < +proposal.modCount) {
      return setPartialPanels(+partialPanels)
    } return setPartialPanels(+panelAmount)
  }, [partialPanels, panelAmount])


  useEffect(() => {

    if (+hasRebate < 2 && +proposal.rebateOverride < 2) {
      return setRebateOverride(+proposal.rebateOverride)
    } if (+proposal.rebateOverride > 1 && +hasRebate === 1) {
      return setRebateOverride(0)
    }
    setRebateOverride(+hasRebate)

  }, [hasRebate, proposal.rebateOverride, rebateOverride])

  // console.log(proposal.rebateOverride, rebateOverride, hasRebate)


  useEffect(() => {
    if ((+proposal.rebateOverride === 1 || +proposal.rebate < 1) && +cpsRebate < 1 && +austinRebate < 1) {
      return setRebate(proposal.rebate)
    }
    let oregonDc = 0
    if (cpsRebate === 0 && austinRebate === 0) {
      if (+hasRebate > 0) {
        let oregonMax = 5000
        let ac = 0
        let pa = +panelAmount
        let rMax = +rebateMax
        let perWatt = +rebatePerWatt
        if (+hasRebate > 1) {
          rMax = oregonMax
        }
        if (+hasRebate === 2) {
          perWatt = 1.80
        }
        if (+hasRebate === 3) {
          perWatt = .20 + +rebatePerWatt
          rMax = (+oregonMax + +rebateMax)
        }
        if (+hasRebate === 4) {
          perWatt = .50
        }
        if (+hasRebate === 5) {
          perWatt = 1.80 + +rebatePerWatt
          rMax = (+oregonMax + +rebateMax)
        }
        if (+proposal.rebatePanels !== +proposal.modCount) {
          pa = partialPanels
        }
        if (rebateType === 'Per Watt A/C') {
          ac = pa * mod[4] * invRating * perWatt
        }
        let dc = 0
        if (rebateType === 'Per Watt D/C') {
          dc = pa * mod[3] * perWatt
          // console.log(dc)
        }
        let fixed = 0
        if (rebateType === 'Fixed') {
          fixed = rebateFixed
        }
        let totalRebate = (ac + dc + fixed)
        if (rebateMax) {
          if (totalRebate >= +rMax) {
            return setRebate(Math.round(+rMax))
          } return setRebate(Math.round(+totalRebate))
        } return setRebate(Math.round(+totalRebate))
      } return setRebate(0 + oregonDc)
    }
  }, [systemSize, hasRebate, salesTeam, rebate, utility, proposal.rebateOverride, cpsRebate, austinRebate])



  // console.log(rebate, partialPanels, panelAmount)

  // console.log(proposal.rebateOverride)

  useEffect(() => {
    if (custUtility === 'Austin Energy') {
      if (panelAmount * mod[4] * invRating < 3000 && (total(production) / total(usage)) < .75) {
        return setRebate(0)
      }
    }
  }, [systemSize, production, panelAmount])


  useEffect(() => {

    if (utilityLocation === 'Virginia' || utilityLocation === 'North Carolina' || utilityLocation === 'South Carolina') {
      setAdderAmount(0)
    }
    let tt = 0
    if (treeRemoval === 1) {
      tt = +treeRemovalAmount
    }
    let rr = 0
    if (reRoof === 1) {
      rr = +reRoofAmount
    }
    let sh = 0
    if (smartHome === 1) {
      sh = +smartHomeAmount
    }
    let hv = 0
    if (hvac === 1) {
      hv = +hvacAmount
    }
    let ld = 0
    if (led === 1) {
      ld = +ledAmount
    }
    let trf = 0
    if (turf === 1) {
      trf = +turfAmount
    }
    let wdw = 0
    if (windows === 1) {
      wdw = +windowsAmount
    }
    let wtr = 0
    if (water === 1) {
      wtr = +waterAmount
    }
    let bal = 0;
    if (ballast === 1) {
      bal = +ballastTotal;
    }
    let gm = 0;
    if (groundMount === 1) {
      gm = +groundMountTotal;
    }
    let ps = 0;
    if (pSolar === 1) {
      ps = +pSolarAmount;
    }
    let tr = 0
    if (travel === 1) {
      tr = +travelAmount
    }
    let adder = 0;
    if (ionRebate === 1 || ionRebate === 2) {
      adder = +adderAmount
    }
    let adder2 = 0
    if (ionRebate2 === 1) {
      adder2 = +adderAmount2
    }
    let slc = 0
    if (slcAdder === 1) {
      slc = +slcAdderAmount
    }
    let ms = 0;
    if (msp === 1) {
      ms = +mspAmount;
    }
    let cg = 0;
    if (critterGuard === 1) {
      cg = +critterGuardAmount;
    }
    let b3 = 0;
    if (battery3 === 1) {
      b3 = +battery3Amount;
    }
    let b10 = 0;
    if (battery10 > 0) {
      b10 = (+battery10Amount * +battery10);
    }
    let sus = 0;
    if (sustainable === 1) {
      sus = +sustainableAmount;
    }
    let na = 0;
    if (nestAdder === 1 && nest < 3) {
      na = +nestAdderAmount;
    }
    if (nestAdder === 1 && nest === 3) {
      na = +nestAdderAmount * 2;
    }
    return setAdderTotal(Math.round((ps + tr + cg) * systemSize + adder + adder2 + slc + ms + sus + gm + bal + b3 + b10 + na + tt + rr + sh + hv + ld + trf + wdw + wtr))
  }, [treeRemoval, treeRemovalAmount, reRoof, reRoofAmount, smartHome, smartHomeAmount, hvac, hvacAmount, led, ledAmount, turf, turfAmount, windows, windowsAmount, water, waterAmount, ballast, ballastTotal, groundMountTotal, groundMountPanels, ionRebate, ionRebate2, groundMount, pSolar, msp, critterGuard, overRide, systemSize, basePpw, panelAmount, travel, travelAmount, adderTotal, custUtility, costOverRide, salesTeam, ppw, loanA, highLoan, battery3, battery10, sameDay, preferredUtility, referral, nestAdder, nest, slcAdder, sustainable])

  let homeEnergyTotal = smartHomeAmount + hvacAmount + ledAmount + turfAmount + windowsAmount + waterAmount

  useEffect(() => {
    let perWatt = +ppw
    let sd = 0;
    if (sameDay === 1) {
      sd = +sameDayAmount;
    }
    let pu = 0;
    if (preferredUtility === 1) {
      pu = +preferredUtilityAmount;
    }
    let ref = 0;
    if (referral === 1) {
      ref = +referralAmount;
    }

    if (costOverRide === '1') {
      return setSystemCost(+proposal.loanAmount + +proposal.rebate + +proposal.downPayment + ref + sd + (pu * systemSize))
    }
    if ((+perWatt * systemSize) < 12500) {
      return setSystemCost(Math.round(12500 + +adderTotal))
    }
    return setSystemCost(Math.round((+perWatt + pu) * systemSize + adderTotal + ref + sd))
  }, [ballast, ballastTotal, groundMountTotal, groundMountPanels, ionRebate, ionRebate2, groundMount, pSolar, msp, critterGuard, overRide, systemSize, basePpw, panelAmount, travel, travelAmount, adderTotal, custUtility, costOverRide, salesTeam, ppw, loanA, highLoan, battery3, battery10, sameDay, preferredUtility, referral, nestAdder, nest, slcAdder, sustainable])

  // console.log(ppw)


  // console.log(rebate)

  // console.log(utilityLocation, systemCost, ppw, custUtility)

  // console.log(loanAmount, costOverRide)

  // billCalc[0] = array of customer's bill amounts for each month
  // billCalc[1] = averageBill
  // billCalc[2] = annualUsage
  // billCalc[3] = annualBill
  // billCalc[4] = averageUsage

  //loan[0] = loanId
  //loan[1] = loanName
  //loan[2] = term
  //loan[3] = interest
  //loan[4] = prePayment
  //loan[5] = postPayment
  //loan[6] = intOnlyPayment

  const twentyFiveYear = (total, years, ratePercent) => {
    let interestRate = ((ratePercent / 100) + 1)
    return (total * Math.pow(interestRate, years)).toFixed(2);
  }


  let loan1Bills = []

  // console.log(twentyFiveYear(billCalc[1], 24, 4))
  // console.log(twentyFiveYear(billCalc[3], 25, 4)*12)
  // console.log(loanA, loanB);


  if (loanA && loanA[6]) {
    loan1Bills = new Array(+loanA[2] - 1).fill(+(loanA[4] * loanAmount).toFixed(2))
    loan1Bills.unshift(+(loanA[6] * loanAmount).toFixed(2));
  } else if (loanA && !loanA[6]) {
    loan1Bills = new Array(+loanA[2]).fill(+(loanA[4] * loanAmount).toFixed(2));
  }

  let loan2Bills = []

  if (loanB && loanB[6]) {
    loan2Bills = new Array(+loanB[2] - 1).fill(+(loanB[4] * loanAmount).toFixed(2))
    loan2Bills.unshift(+(loanB[6] * loanAmount).toFixed(2));
  } else if (loanB && !loanB[6]) {
    loan2Bills = new Array(loanB[2]).fill(+(loanB[4] * loanAmount).toFixed(2));
  }

  let increase = 4
  if (custUtility === 'Austin Energy') {
    increase = 2
  } else {
    increase = 4
  }


  let years = []
  if (janProduction) {
    for (let i = 0; i <= 24; i++) {
      years.push(+twentyFiveYear(+billCalc[1], i, increase))
    }
  } else {
    years.push(0)
  }

  let postYears = []

  if (postBill) {
    for (let i = 0; i <= 24; i++) {
      postYears.push(+twentyFiveYear(+postBill[1], i, increase))
    }
  } else {
    postYears.push(0)
  }

  let postYears1 = []

  if (postBill) {
    for (let i = 0; i <= 24; i++) {
      postYears1.push(+twentyFiveYear(35, i, increase))
    }

  } else {
    postYears1.push(0)
  }
  // console.log(postYears)

  const addPanel = () => {
    setPanelAmount(panelAmount + 1)
  }
  // console.log(pRatio)


  const removePanel = () => {
    setPanelAmount(panelAmount - 1)
  }

  let nestPanelAmount = 1
  if (nestMax > .05) {
    nestPanelAmount = 2
  }

  const nestPanels = () => {
    if (nest) {
      return setPanelAmount(panelAmount + nestPanelAmount)
    } if (!nest) {
      return setPanelAmount(panelAmount - nestPanelAmount)
    }
  }

  let disableNest = true;

  if (panelAmount + nestPanelAmount >= +maxModCount || proposal.maxOffset && (totalProduction / totalUsage) * 100 >= (+proposal.maxOffset * .97)) {
    disableNest = true
  } else if (+proposal.hasNest > 0 && nest > 0) {
    disableNest = false
  } else if (+proposal.hasNest === 0 && nest === 0) {
    disableNest = false
  }

  // console.log(nest, disableNest, nestPanelAmount)


  let saving = []
  let savings = []
  let years1 = []
  let save = []

  const savingsCalc = (arr) => {
    postYears.slice(0, arr.length)
    years1 = postYears.slice(- (25 - arr.length), 25)
    for (let i = 0; i < arr.length; i++) {
      saving.push(postYears[i] + arr[i])
    }
    save = saving.concat(years1)
    // console.log('saving', saving)
    for (let i = 0; i <= years.length - 1; i++) {
      savings.push(years[i] - save[i])
    }
    savings = savings.map(x => x * 12)
    // console.log('savings', savings)
    return total(savings)
  }

  // console.log(postYears)


  let saving1 = []
  let savings1 = []
  let years11 = []
  let save1 = []

  const savingsCalc1 = (arr) => {
    postYears.slice(0, arr.length)
    years11 = postYears.slice(- (25 - arr.length), 25)
    for (let i = 0; i < arr.length; i++) {
      saving1.push(postYears[i] + arr[i])
    }
    save1 = saving1.concat(years11)
    // console.log(save1)
    for (let i = 0; i <= years.length - 1; i++) {
      savings1.push(years[i] - save1[i])
    }
    savings1 = savings1.map(x => x * 12)
    // console.log(savings1)
    return total(savings1)
  }



  // console.log('postYears', postYears, 'postBill', postBill, 'years', years, newBill, usage)


  const utilityOffset = () => {
    if (Math.round(100 - (totalProduction / +totalUsage * 100)) <= 0) {
      return <span className={uType === 'Square Footage' ? ' noDisplay' : ''}>0%</span>
    } return <span className={uType === 'Square Footage' ? ' noDisplay' : ''}>{Math.round(100 - (totalProduction / +totalUsage * 100))}%</span>
  }

  const offset = Math.round((totalProduction / +totalUsage * 100))

  // console.log(offset)

  //loan[0] = loanId
  //loan[1] = loanName
  //loan[2] = term
  //loan[3] = interest
  //loan[4] = prePayment
  //loan[5] = postPayment
  //loan[6] = intOnlyPayment

  // let mappedLoans1 = loanProducts.map((loans, i) => {
  //   // console.log(loans.loanTerm)
  //   let info = [loans.loanId, loans.loanName, +loans.loanTerm, +loans.loanInterest, +loans.prePayment, +loans.postPayment, +loans.interestOnlyPayment, +loans.itc]
  //   return <MenuItem key={i} value={info} onClick={() => { handleClose1(); setLoanA(info) }}> {`${loans.loanName} ${loans.loanTerm} yr ${loans.loanInterest}`}</MenuItem>
  // })


  let mappedLoans = loanProducts.map((loans, i) => {
    // console.log(loans.loanTerm)
    let info = [+loans.loanId, loans.loanName, +loans.loanTerm, +loans.loanInterest, +loans.prePayment, +loans.postPayment, +loans.interestOnlyPayment, +loans.itc, +loans.specialPrice]
    return <MenuItem key={i} value={info} onClick={() => { handleClose1(); setLoanA(info) }}> {`${loans.loanName} ${loans.loanTerm} yr ${loans.loanInterest}`}</MenuItem>
  })

  let mappedLoans2 = loanProducts2.map((loans, i) => {
    // console.log(loans.loanTerm)
    let info = [+loans.loanId, loans.loanName, +loans.loanTerm, +loans.loanInterest, +loans.prePayment, +loans.postPayment, +loans.interestOnlyPayment, +loans.itc, +loans.specialPrice]
    return <MenuItem key={i} value={info} onClick={() => { handleClose2(); setLoanB(info) }}> {`${loans.loanName} ${loans.loanTerm} yr ${loans.loanInterest}`}</MenuItem>
  })



  const prePayment = () => {
    if (custUtility === 'Oncor' || custUtility === 'TXU' || custUtility === 'Reliant' || custUtility === 'Green Mountain Energy' || custUtility === 'PEC - Pedernales Electric Cooperative' || custUtility === 'GVEC -Guadalupe Valley Electric Cooperative' || custUtility === 'Bluebonnet Electric Cooperative' || custUtility === 'NBU- New Braunfels Utilities' || custUtility === 'City of Boerne Public Utilities' || custUtility === 'City Public Service (CPS)' || custUtility === 'Colorado Springs Utilities' || custUtility === 'City of Georgetown Utility' || custUtility === 'Portland General Electric (PGE)' || custUtility === 'Pacific Power') {
      return Math.round(loanA[4] * loanAmount)
    }
    let tax = stateTax;
    if (utilityLocation === 'South Carolina') {
      tax = 3500
    }
    if (stateTax > 0 && loanA[1] === 'Dividend') {

      if (loanA[6] > 0) {
        let a = (loanA[3] / 100) / 12
        let b = a + 1
        let c = loanA[2] * 12 - 16
        let d = Math.pow(b, -c)
        let e = 1 - d
        let f = a / e
        let g = f * (loanAmount * .74 - tax)

        return Math.round(g)
      }
      let a = (loanA[3] / 100) / 12
      let b = a + 1
      let c = loanA[2] * 12 - 6
      let d = Math.pow(b, -c)
      let e = 1 - d
      let f = a / e
      let g = f * (loanAmount * .74 - tax)

      return Math.round(g)
    }
    if (stateTax > 0 && loanA[1] === 'Sunlight') {
      let a = (loanA[3] / 100) / 12
      let b = a + 1
      let c = loanA[2] * 12 - 6
      let d = Math.pow(b, -c)
      let e = 1 - d
      let f = a / e
      let g = f * (loanAmount * .74 - tax)

      return Math.round(g)
    }
    if (stateTax > 0 && loanA[1] === 'Mosaic') {
      let a = (loanA[3] / 100) / 12
      let b = a + 1
      let c = loanA[2] * 12 - 6
      let d = Math.pow(b, -c)
      let e = 1 - d
      let f = a / e
      let g = f * (loanAmount * .74 - tax)

      return Math.round(g)
    }
    if (stateTax > 0 && loanA[1] === 'GoodLeap 22') {
      let a = (loanA[3] / 100) / 12
      let b = a + 1
      let c = loanA[2] * 12 - 6
      let d = Math.pow(b, -c)
      let e = 1 - d
      let f = a / e
      let g = f * (loanAmount * .78 - tax)

      return Math.round(g)
    }
    if (stateTax > 0 && loanA[1] === 'GoodLeap') {
      let a = (loanA[3] / 100) / 12
      let b = a + 1
      let c = loanA[2] * 12 - 6
      let d = Math.pow(b, -c)
      let e = 1 - d
      let f = a / e
      let g = f * (loanAmount * .74 - tax)

      return Math.round(g)
    }
    if (rebate > 0 && loanA[1] === 'Dividend') {

      if (loanA[6] > 0) {
        let a = (loanA[3] / 100) / 12
        let b = a + 1
        let c = loanA[2] * 12 - 16
        let d = Math.pow(b, -c)
        let e = 1 - d
        let f = a / e
        let g = f * (loanAmount * .74 - rebate)

        return Math.round(g)
      }
      let a = (loanA[3] / 100) / 12
      let b = a + 1
      let c = loanA[2] * 12 - 6
      let d = Math.pow(b, -c)
      let e = 1 - d
      let f = a / e
      let g = f * (loanAmount * .74 - rebate)

      return Math.round(g)
    }
    if (rebate > 0 && loanA[1] === 'Sunlight') {
      if (custUtility === 'Austin Energy') {

        let a = (loanA[3] / 100) / 12
        let b = a + 1
        let c = loanA[2] * 12 - 12
        let d = Math.pow(b, -c)
        let e = 1 - d
        let f = a / e
        let g = f * (loanAmount * .74 - rebate)

        return Math.round(g)
      }
      let a = (loanA[3] / 100) / 12
      let b = a + 1
      let c = loanA[2] * 12 - 6
      let d = Math.pow(b, -c)
      let e = 1 - d
      let f = a / e
      let g = f * (loanAmount * .74 - rebate)

      return Math.round(g)
    }
    if (rebate > 0 && loanA[1] === 'GoodLeap') {
      if (custUtility === 'Austin Energy') {

        let a = (loanA[3] / 100) / 12
        let b = a + 1
        let c = loanA[2] * 12 - 12
        let d = Math.pow(b, -c)
        let e = 1 - d
        let f = a / e
        let g = f * (loanAmount * .74 - rebate)

        return Math.round(g)
      }
      let a = (loanA[3] / 100) / 12
      let b = a + 1
      let c = loanA[2] * 12 - 6
      let d = Math.pow(b, -c)
      let e = 1 - d
      let f = a / e
      let g = f * (loanAmount * .74 - rebate)

      return Math.round(g)
    }
    if (rebate > 0 && loanA[1] === 'Dividend') {
      if (custUtility === 'Salem Electric') {

        let a = (loanA[3] / 100) / 12
        let b = a + 1
        let c = loanA[2] * 12 - 12
        let d = Math.pow(b, -c)
        let e = 1 - d
        let f = a / e
        let g = f * (loanAmount * .74 - rebate)

        return Math.round(g)
      }
      let a = (loanA[3] / 100) / 12
      let b = a + 1
      let c = loanA[2] * 12 - 6
      let d = Math.pow(b, -c)
      let e = 1 - d
      let f = a / e
      let g = f * (loanAmount * .74 - rebate)
      return Math.round(g)
    }
    if (rebate > 0 && loanA[1] === 'GoodLeap 22') {
      if (custUtility === 'Austin Energy') {

        let a = (loanA[3] / 100) / 12
        let b = a + 1
        let c = loanA[2] * 12 - 12
        let d = Math.pow(b, -c)
        let e = 1 - d
        let f = a / e
        let g = f * (loanAmount * .78 - rebate)

        return Math.round(g)
      }
      let a = (loanA[3] / 100) / 12
      let b = a + 1
      let c = loanA[2] * 12 - 6
      let d = Math.pow(b, -c)
      let e = 1 - d
      let f = a / e
      let g = f * (loanAmount * .74 - rebate)

      return Math.round(g)
    }
    return Math.round(loanA[4] * loanAmount)

  }


  //loan[0] = loanId
  //loan[1] = loanName
  //loan[2] = term
  //loan[3] = interest
  //loan[4] = prePayment
  //loan[5] = postPayment
  //loan[6] = intOnlyPayment

  // const monthlyPayments = (+loanA[2] * 12) - 18
  const monthlyPayments = () => {
    if (loanA[6] > 0) {
      return (loanA[2] * 12) - 16
    } return (loanA[2] * 12) - 18
  }

  // console.log(custUtility, prePayment())


  const postPayment = () => {
    if (stateTax || custUtility === 'City of Fort Collins Utilities (FCU)' || custUtility === 'Salem Electric' || (custUtility === 'Austin Energy' && rebate > 0)) {
      return <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'baseline' }}>
        <div style={{ display: 'flex', flexDirection: 'column' }}>
          <span style={{ fontSize: '3rem' }}>${Math.round(loanA[4] * loanAmount)}</span>
        </div>
        <div className='font'>
          {loanA[6] > 0 ? (
            <>
              <span className='fontTest' >{monthlyPayments()} MONTHLY PAYMENTS IF ONLY FEDERAL<br /> TAX CREDIT APPLIED TO LOAN:</span>
            </>
          ) : (
            <>
              <span className='fontTest' >{monthlyPayments()} MONTHLY PAYMENTS IF UTILITY REBATE &<br /> FEDERAL TAX CREDIT APPLIED TO LOAN:</span>
            </>
          )}
          <span >${prePayment()}</span>
        </div>
      </div>
    } return <span style={{ fontSize: '3rem' }}>${prePayment()}</span>
  }

  // console.log(utilityLocation)


  //ENVIRONMENTAL IMPACT CALCULATIONS BELOW

  const gallons = () => {
    let one = (totalProduction) * (-0.000689551)
    if (nest > 0) {
      one = (totalProduction - nestAmount) * (-0.000689551)
    }
    let two = -one
    let three = two * 1.10231
    let four = three * 67629
    return Math.round(four / 25)
  }


  const homes = () => {
    let one = (totalProduction) * (25)
    if (nest > 0) {
      one = (totalProduction - nestAmount) * (25)
    }
    return Math.round(one / 10000)
  }

  const garbages = () => {
    let one = (totalProduction) * (-0.000689551)
    if (nest > 0) {
      one = (totalProduction - nestAmount) * (-0.000689551)
    }
    let two = -one
    let three = two * 1.10231
    let four = three * 36
    return Math.round(four)
  }

  const trees = () => {
    let one = (totalProduction) * (-0.000689551)
    if (nest > 0) {
      one = (totalProduction - nestAmount) * (-0.000689551)
    }
    let two = -one
    let three = two * 1.10231
    let four = three * 798
    return Math.round(four)
  }
  let avg25_1;
  let ionCostA;

  if (loanA) {
    avg25_1 = (((total(loan1Bills) * 12) / 25) / totalProduction).toFixed(2)
    ionCostA = Math.round(total(loan1Bills) * 12)
  }
  const gallon = gallons()
  const home = homes()
  const garbage = garbages()
  const tree = trees()



  let nestImpact = Math.round(nestAmount / totalUsage * 100)

  if (nest === 0) {
    nestImpact = '-'
  }

  let utilityPower = Math.round(100 - (totalProduction / totalUsage) * 100)
  if (utilityPower < 0) {
    utilityPower = 0
  }
  let solarPower = Math.round((totalProduction / totalUsage) * 100)

  let janU = Math.round(usage[0])
  let febU = Math.round(usage[1])
  let marU = Math.round(usage[2])
  let aprU = Math.round(usage[3])
  let mayU = Math.round(usage[4])
  let junU = Math.round(usage[5])
  let julyU = Math.round(usage[6])
  let augU = Math.round(usage[7])
  let sepU = Math.round(usage[8])
  let octU = Math.round(usage[9])
  let novU = Math.round(usage[10])
  let decU = Math.round(usage[11])

  let janP = Math.round(production[0])
  let febP = Math.round(production[1])
  let marP = Math.round(production[2])
  let aprP = Math.round(production[3])
  let maP = Math.round(production[4])
  let junP = Math.round(production[5])
  let julP = Math.round(production[6])
  let augP = Math.round(production[7])
  let sepP = Math.round(production[8])
  let octP = Math.round(production[9])
  let novP = Math.round(production[10])
  let decP = Math.round(production[11])

  const cost25yr = Math.round(total(years) * 12)

  const currAnnBill = Math.round(years[0] * 12)

  const today = Math.round(years[0])
  const yr5 = Math.round(years[4])
  const yr10 = Math.round(years[9])
  const yr15 = Math.round(years[14])
  const yr20 = Math.round(years[19])
  const yr25 = Math.round(years[24])

  const avg25Utility = ((total(years) * 12 / 25) / totalUsage).toFixed(2)
  const avg25_2 = (((total(loan2Bills) * 12) / 25) / totalProduction).toFixed(2)

  let netCost = Math.round(+loanAmount + +downPayment - ((+loanAmount + +downPayment - homeEnergyTotal) * loanA[7]) - stateTax)
  if (custUtility === 'City of Fort Collins Utilities (FCU)' || custUtility === 'Austin Energy') {
    netCost = Math.round(+loanAmount - +rebate + +downPayment - ((+loanAmount + +downPayment - homeEnergyTotal) * loanA[7]) - stateTax)
  }
  const itcTotal = (loanAmount + +downPayment - homeEnergyTotal) * loanA[7]
  const allIncentives = Math.round(itcTotal + stateTax)

  const pmt1 = prePayment()
  const pmt2 = Math.round(loanAmount * loanA[5])
  const pmt3 = Math.round(loanAmount * loanA[6])
  const pmt1B = Math.round(loanAmount * loanB[4])
  const pmt2B = Math.round(loanAmount * loanB[5])
  const loan1Savings = savingsCalc(loan1Bills)
  const loan2Savings = savingsCalc1(loan2Bills)

  const ionCostB = Math.round(total(loan2Bills) * 12)
  let remainingCost = Math.round(total(postYears) * 12)
  if (remainingCost <= 0) {
    remainingCost = Math.round(total(postYears1))
  }
  const currentPerKw = (billCalc[1] / billCalc[4]).toFixed(3)


  // console.log(loan1Savings)



  useEffect(() => {
    if (custUtility === 'City Public Service (CPS)' || custUtility === 'Colorado Springs Utilities' || custUtility === 'Portland General Electric (PGE)' || custUtility === 'Pacific Power') {
      setRebateSF(rebate)
    }
  }, [rebate, custUtility])



  // useEffect(() => {
  //   if (panelAmount === +maxModCount) {
  //     Alert.success(`Reached maximum of ${maxModCount} panels that fit on home`, {
  //       position: 'top-right',
  //       effect: 'flip',
  //       beep: false,
  //       timeout: 5000,
  //       offset: 100,

  //     })
  //   }
  // }, [panelAmount])

  const [displayProd, setDisplayProd] = useState('')

  useEffect(() => {
    if (nest === 1 || nest > 1) {
      return setDisplayProd(Math.round((+totalProduction - +nestAmount)))
    } return setDisplayProd(Math.round(+totalProduction))
  }, [nest, totalProduction])

  // console.log(displayProd, +totalProduction, production, julyP)

  const adderToggle = (num, operation) => {
    if (num === 1 || num === 2) {
      return operation(0)
    } operation(1)
  }

  const repAdderToggle = (num, operation, number) => {
    if (num === number && +proposal.ionRebate < 1) {
      return operation(0)
    } operation(number)
  }

  // console.log(proposal.ionRebate)

  const adderToggle2 = (num, operation) => {
    if (num === 2) {
      return operation(0)
    } operation(2)
  }

  const adderToggleBattery = (num, operation) => {
    if (num > 0) {
      return operation(0)
    } operation(1)
  }

  const adderToggleOregon = (num, operation, number) => {
    if (+num === 1) {
      return operation(5)
    }
    if (+num === 5) {
      return operation(1)
    }
    if (+num > 1 && +num < 5) {
      return operation(0)
    } operation(number)
  }
  // console.log(hasRebate)

  const handleChangeBattery = (event) => {
    setBattery10(event.target.value);
  };

  const handleChangeMilitary = (event) => {
    setMilitary(event.target.value);
  };

  const handleChangeNest = (event) => {
    setNest(event.target.value);
  };


  const adderToggleNest = (num, operation) => {
    if (num === 1 || num > 1) {
      return operation(0)
    } operation(1)
  }

  // console.log(nest, totalProduction, displayProd)




  let propVersion = props.match.params.number


  //Material UI functions for the dynamic proposal.

  // console.log(loanA[6])

  //loan[0] = loanId
  //loan[1] = loanName
  //loan[2] = term
  //loan[3] = interest
  //loan[4] = prePayment
  //loan[5] = postPayment
  //loan[6] = intOnlyPayment

  const [slider, setSlider] = useState(false)

  // https://apply.goodleap.com/solar/ion/20299.html??refnum=a004T00000L5fb0QAB&lname=Reid&fname=Taia&street=2002%20Chartwell%20Dr.&city=Newport%20News&state=VA&zip=23608&email=taialcreid%40gmail.com&phone=&cost=14652&language=English&srfn=Michael&srln=Shafer&sre=m.shafer%40ionsolar.com


  let linkName = []
  let linkStreet;
  let cityLink;
  let stateLink;
  let emailLink = ''
  let repEmailLink;
  let repPhoneLink;
  let repNameLink = []
  let financingLink;
  let phoneLink = ''
  let loanLink1;
  let loanLink2;


  if (state === 'Texas') {
    stateLink = 'TX'
  }
  if (state === 'Utah') {
    stateLink = 'UT'
  }
  if (state === 'Virginia') {
    stateLink = 'VA'
  }
  if (state === 'Oregon') {
    stateLink = 'OR'
  }
  if (state === 'Nevada') {
    stateLink = 'NV'
  }
  if (state === 'New Mexico') {
    stateLink = 'NM'
  }
  if (state === 'North Carolina') {
    stateLink = 'NC'
  }
  if (state === 'South Carolina') {
    stateLink = 'SC'
  }
  if (state === 'Colorado') {
    stateLink = 'CO'
  }

  if (name && currentProp) {
    linkName = name.split(' ')
    linkStreet = street.replace(' ', '%20')
    cityLink = city.replace(' ', '%20')
    if (customer.email) {
      emailLink = customer.email.replace('@', '%40')
    }
    repNameLink = customer.salesRep.split(' ')
    repEmailLink = customer.repEmail.replace('@', '%40')
    financingLink = currentProp.financingAmount
    if (phone) {
      phoneLink = phone.replace(/\D/g, '')
    }
    repPhoneLink = customer.repPhone.replace(/\D/g, '')
    if (loanA.length > 1) {
      loanLink1 = `${loanA[2]}${loanA[3].toString().replace('.', '')}`
      loanLink2 = `${loanB[2]}${loanB[3].toString().replace('.', '')}`
    }
  }


  let link1;
  let link2;

  const [linkCost, setLinkCost] = useState()

  useEffect(() => {
    let pu = 0
    let sd = 0
    let ref = 0
    if (sameDay === 1) {
      sd = +sameDayAmount
    }
    if (preferredUtility === 1) {
      pu = +preferredUtilityAmount * systemSize
    }
    if (referral === 1) {
      ref = +referralAmount
    }
    return setLinkCost(+systemCost - +pu - +sd - +ref)

  }, [preferredUtility, sameDay, referral, systemCost])

  const creditCheck = () => {
    if (loanA[1] === 'Dividend') {
      link1 = `https://partner.dividendfinance.com/application/IonSolar?borrower_first-name=${linkName[0]}&borrower_last-name=${linkName[1]}&borrower_phone=${phoneLink}&borrower_email=${emailLink}&address_street1=${linkStreet}&address_city=${cityLink}&address_state=${stateLink}&address_zip=${zip}&project_project-cost=${loanAmount}&project_system-size=${systemSize / 1000}&installer_sales-rep-email=${repEmailLink}&project_product_term=${loanA[2]}&project_product_rate=${(+loanA[3] / 100).toFixed(4)}&external-project-id=${customer.projectId}` // todo add salesforce project id here external-project-id=${customer.projectId}
    }
    if (loanA[1] === 'Ygrene') {
      link1 = 'https://portal.ygrene.com/#/login'
    }
    if (loanA[1] === 'Sunlight' || loanA[1] === 'Sunlight Int Only') {
      link1 = 'https://slfportal.com/orange/#/'
    }
    if (loanA[1] === 'GoodLeap' || loanA[1] === 'GoodLeap 22') {
      link1 = `https://apply.goodleap.com/solar/ion/${loanLink1}.html??refnum=${customer.projectID}&lname=${linkName[1]}&fname=${linkName[0]}&street=${linkStreet}&city=${cityLink}&state=${stateLink}&zip=${zip}&email=${emailLink}&phone=${phoneLink}&cost=${financingLink}&language=English&srfn=${repNameLink[0]}&srln=${repNameLink[1]}&sre=${repEmailLink}&srphone=${repPhoneLink}`
    }
    return <a href={link1} target='_blank' >
      <Button style={{ display: 'flex', justifyContent: 'space-between', width: '100%', height: '70px' }}>
        <LinkRoundedIcon />
        <span style={{ fontSize: '1.2rem', textDecoration: 'none' }}>{loanA[1]} {loanA[2]} yr {loanA[3]}</span>
      </Button>
    </a>
  }

  const creditCheck2 = () => {
    if (loanB[1] === 'Dividend') {
      link2 = `https://partner.dividendfinance.com/application/IonSolar?borrower_first-name=${linkName[0]}&borrower_last-name=${linkName[1]}&borrower_phone=${phoneLink}&borrower_email=${emailLink}&address_street1=${linkStreet}&address_city=${cityLink}&address_state=${stateLink}&address_zip=${zip}&project_project-cost=${loanAmount}&project_system-size=${systemSize / 1000}&installer_sales-rep-email=${repEmailLink}&project_product_term=${loanB[2]}&project_product_rate=${(+loanB[3] / 100).toFixed(4)}&external-project-id=${customer.projectId}` // todo add salesforce project id here external-project-id=${customer.projectId}
    }
    if (loanB[1] === 'Ygrene') {
      link2 = 'https://portal.ygrene.com/#/login'
    }
    if (loanB[1] === 'Sunlight' || loanA[1] === 'Sunlight Int Only') {
      link2 = 'https://slfportal.com/orange/#/'
    }
    if (loanB[1] === 'GoodLeap' || loanA[1] === 'GoodLeap 22') {
      if (loanB[2] === 10) {
        if (loanB[3] === 2.99) {
          link2 = 'https://apply.goodleap.com/solar/ion/ion.html'
        }
      }
      link2 = `https://apply.goodleap.com/solar/ion/${loanLink2}.html??refnum=${customer.projectID}&lname=${linkName[1]}&fname=${linkName[0]}&street=${linkStreet}&city=${cityLink}&state=${stateLink}&zip=${zip}&email=${emailLink}&phone=${phoneLink}&cost=${financingLink}&language=English&srfn=${repNameLink[0]}&srln=${repNameLink[1]}&sre=${repEmailLink}&srphone=${repPhoneLink}`
    }
    return <a href={link2} target='_blank' >
      <Button style={{ display: 'flex', justifyContent: 'space-between', width: '100%', height: '70px' }}>
        <LinkRoundedIcon />
        <span style={{ fontSize: '1.2rem', textDecoration: 'none' }}>{loanB[1]} {loanB[2]} yr {loanB[3]}</span>
      </Button>
    </a>
  }



  const [anchorPanel, setAnchorPanel] = useState(null);
  const [anchorLoan1, setAnchorLoan1] = useState(null);
  const [anchorLoan12, setAnchorLoan12] = useState(null);
  const [anchorLoan2, setAnchorLoan2] = useState(null);
  const [anchorLoan22, setAnchorLoan22] = useState(null);
  const [anchorPricing, setAnchorPricing] = useState(null);
  const [anchorNest, setAnchorNest] = useState(null);
  const [anchorCash, setAnchorCash] = useState(null);


  const handleClick = event => {
    setAnchorPanel(event.currentTarget);
  };
  const handleClick1 = event => {
    setAnchorLoan1(event.currentTarget);
  };
  const handleClick12 = event => {
    setAnchorLoan12(event.currentTarget);
  };
  const handleClick2 = event => {
    setAnchorLoan2(event.currentTarget);
  };
  const handleClick22 = event => {
    setAnchorLoan22(event.currentTarget);
  };
  const handleClick3 = event => {
    setAnchorPricing(event.currentTarget);
  };
  const handleClick4 = event => {
    setAnchorNest(event.currentTarget);
  };
  const handleClick5 = event => {
    setAnchorCash(event.currentTarget);
  };


  // console.log(anchorPanel)

  const handleClose = () => {
    setAnchorPanel(null);
  };

  const handleClose1 = () => {
    setAnchorLoan1(null);
  };
  const handleClose12 = () => {
    setAnchorLoan12(null);
  };

  const handleClose2 = () => {
    setAnchorLoan2(null);
  };
  const handleClose22 = () => {
    setAnchorLoan22(null);
  };

  const handleClose3 = () => {
    setAnchorPricing(null);
  };

  const handleClose4 = () => {
    setAnchorNest(null);
  };

  const handleClose5 = () => {
    setAnchorCash(null)

  };

  // const setCashPricing = (num) => {
  //    setCashPpw(num)


  // }



  let mappedModules = modules.filter(item => {
    return item.modId === '6' || item.modId === '8'
  }).map((mod, i) => {
    let info = [mod.modId, mod.make, mod.model, mod.size, mod.ptcRating]
    // console.log(info)
    return <MenuItem selected={i === 'Select This'} key={i} value={info} onClick={() => { handleClose(); setMod(info) }}> {`${mod.make} ${mod.model} ${mod.size}`}</MenuItem>
  })


  const sendCia = () => {
    axios.post(`https://dev.iondeveloper.com/api/rep/docusign/?api_key=${process.env.REACT_APP_API_KEY}`, { method: 'send_CIA2', project_id: customer.projectID }).then((res) => {
      // console.log(res.data)
      Alert.success(`CIA sent to ${customer.email}`, {
        position: 'top-right',
        effect: 'flip',
        beep: false,
        timeout: 5000,
        offset: 100,
        color: 'rgba(255, 255, 255, 0.927)'
      })
      setCiaLoading(false)
    })
  }

  const updateCashCia = () => {
    axios.post(`https://dev.iondeveloper.com/api/proposal/proposal-tool/?api_key=${process.env.REACT_APP_API_KEY}`, { method: 'update_cash_cia', id: customer.financeId, id2: customer.projectID, Primary_Financing_Amount__c: (currentProp.systemSize * +cashPpw) + +currentProp.adderTotal }).then((res) => {
      // updateProduction()
      // console.log(res.data)
      Alert.success(`Price Adjusted for Cash Agreement`, {
        position: 'top-right',
        effect: 'flip',
        beep: false,
        timeout: 5000,
        offset: 100,
        color: 'rgba(255, 255, 255, 0.927)'
      })
      getCustomer()
      // setCiaLoading(false)
      setViewCashCia(false)
      sendCia()
    })
  }

  const mappedAdders = adders.map((adder, i) => {
    return <div key={i}>

      <span>{adder.name === 'Adder' || adder.name === 'Home Energy Efficiency Upgrade' ? adder.type : adder.name} {adder.name === 'Thermostat (Free)' ? adder.type : ''} {adder.name === 'Thermostat (Free)' || adder.name === 'LED Light Bulbs (Free)' ? Math.round(adder.quantity) : adder.type === 'Tree Removal' || adder.type === 'Reroof' || adder.type === 'Pool Solar' ? `Quote: $${Math.round(adder.amount)} Fee: $${Math.round(adder.fee)} Total: $${Math.round(adder.totalAmount)}` : adder.name === 'Rep Cash Bonus' ? `$${Math.round(adder.amount)} (Internal - not displayed on CIA)` : adder.type === 'Battery - Encharge 10' || adder.type === 'Service Panel Replacement' || adder.name === 'Military Discount (Check sent at PTO)' || adder.name === 'MISC Cash' || adder.name === 'BlackFriday' ? `$${Math.round(adder.totalAmount)}` : adder.name === 'Cash (Check sent at PTO)' ? `$${adder.amount}` : adder.type === 'Service Panel Replacement - Utah' || adder.type === 'Service Panel Replacement - Oregon' ? '$1000' : ''}</span>
    </div>
  })


  let adderIds = []

  for (let i = 0; i < adders.length; i++) {
    adderIds.push(adders[i].id)
  }

  const add500 = () => {
    axios.post(`https://dev.iondeveloper.com/api/proposal/proposal-tool/?api_key=${process.env.REACT_APP_API_KEY}`, { method: 'add_500', financing_id: customer.financeId, project_id: customer.projectID }).then((res) => {
      console.log(res.data)
      // getCustomer()
      Alert.success(`	Cash (Check sent at PTO) added to Incentives`, {
        position: 'top-right',
        effect: 'flip',
        beep: false,
        timeout: 5000,
        offset: 100,
        color: 'rgba(255, 255, 255, 0.927)'
      })
    })
  }

  const add500Rep = () => {
    axios.post(`https://dev.iondeveloper.com/api/proposal/proposal-tool/?api_key=${process.env.REACT_APP_API_KEY}`, { method: 'add_500_rep', financing_id: customer.financeId, project_id: customer.projectID }).then((res) => {
      console.log(res.data)
      // getCustomer()
      Alert.success(`Rep Cash Bonus added.`, {
        position: 'top-right',
        effect: 'flip',
        beep: false,
        timeout: 5000,
        offset: 100,
        color: 'rgba(255, 255, 255, 0.927)'
      })
    })
  }

  const addBattery10 = () => {
    axios.post(`https://dev.iondeveloper.com/api/proposal/proposal-tool/?api_key=${process.env.REACT_APP_API_KEY}`, { method: 'add_battery_10', financing_id: customer.financeId, project_id: customer.projectID, Amount__c: 13333.33 }).then((res) => {
      console.log(res.data)
      // getCustomer()
      Alert.success(`Encharge10 added`, {
        position: 'top-right',
        effect: 'flip',
        beep: false,
        timeout: 5000,
        offset: 100,
        color: 'rgba(255, 255, 255, 0.927)'
      })
    })
  }

  const [setter, setSetter] = useState('')

  useEffect(() => {
    if (customer.setter === false) {
      if (utilityLocation === 'Texas') {
        return setSetter(0)
      } if (salesTeam === 'Las Vegas Sales Team II' || salesTeam === 'Las Vegas Sales Team 3' || salesTeam === 'Virginia Beach Sales Team' || salesTeam === 'Denver Sales Team' || salesTeam === 'Colorado Springs Sales Team') {
        return setSetter(0)
      }
      return setSetter(.20)
    }
  }, [salesTeam, customer.setter])

  useEffect(() => {
    if (+teamPpw > 0) {
      if (+proposal.specialPrice1 > 0 && +specialLoanIncrease === 1) {
        return setBasePpw(+proposal.specialPrice1 - setter)
      }
      return setBasePpw(+teamPpw - setter)
    }
  }, [teamPpw, proposal, specialLoanIncrease])


  useEffect(() => {
    if (cpsRebate === 0 && austinRebate === 0) {
      if (loanChangeSize > 0 && +team.id1 === +loanA[0]) {
        if (systemSize >= +loanChangeSize) {
          setLoanA([+id3,
            loan3,
          +term3,
          +int3,
          +pre3,
          +post3,
          +interest3,
          +itc3,
          +specialPrice3])
          setPpw(+proposal.ppw + +loanChangeIncrease)
        } else {
          return setLoanA([
            +proposal.id1,
            proposal.loan1,
            +proposal.term1,
            +proposal.int1,
            +proposal.pre1,
            +proposal.post1,
            +proposal.interest1,
            +proposal.itc1,
            +proposal.specialPrice1
          ]),
            setPpw(+proposal.ppw)
        }
      }
    }
  }, [systemSize, loanChangeSize, cpsRebate, austinRebate])

  useEffect(() => {
    if (cpsRebate === 0 && austinRebate === 0) {
      if (loanA[8] > 0 && salesTeam !== 'Las Vegas Sales Team II' && +specialLoanIncrease === 1) {
        return setPpw(loanA[8]),
          setBasePpw(loanA[8] - setter)
      } setPpw(+proposal.ppw)
      setBasePpw(+teamPpw - setter)
    }

  }, [loanA, salesTeam, proposal, cpsRebate, austinRebate])

  useEffect(() => {
    if (salesTeam === 'Las Vegas Sales Team II' || salesTeam === 'Las Vegas Sales Team 3') {
      if (+loanA[8] > 0) {
        setLoanB([49, 'Dividend', 12, 0.99, 0.0055200000000000000, 0.0076600000000000000, 0, 0.26])
        setHighLoan(.20)
        if (+basePpw !== +proposal.ppw) {
          setPpw(+proposal.ppw + highLoan)
        } setPpw(+basePpw + highLoan)
        // setPpw(+proposal.ppw + highLoan)
      } else {
        return setLoanB([
          +proposal.id2,
          proposal.loan2,
          +proposal.term2,
          +proposal.int2,
          +proposal.pre2,
          +proposal.post2,
          +proposal.interest2,
          +proposal.itc2
        ]),
          setHighLoan(0)
        // setPpw(+proposal.ppw)
      }
      if (loanA[8] > 0) {
        if (+proposal.id1 === +loanA[0]) {
          return setPpw(+proposal.ppw)
        }
      }
    }

  }, [proposal, salesTeam, loanA, highLoan])

  useEffect(() => {
    if (custUtility === 'City Public Service (CPS)') {
      if (cpsRebate === 1) {
        return setLoanA([
          17,
          'GoodLeap',
          20,
          4.99,
          0.0050400000000000000,
          0.0068400000000000000,
          0,
          .26,
          0
        ]),
          setLoanB([
            31,
            'GoodLeap',
            12,
            2.99,
            0.0062500000000000000,
            0.0086752000000000000,
            0,
            .26,
            0
          ]),
          setBasePpw(4),
          setPpw(4),
          setRebate(2500),
          setIonRebate(0)
      }
    }
  }, [cpsRebate])

  useEffect(() => {
    if (custUtility === 'Austin Energy') {
      if (austinRebate === 1) {
        return setLoanA([
          17,
          'GoodLeap',
          20,
          4.99,
          0.0050400000000000000,
          0.0068400000000000000,
          0,
          .26,
          0
        ]),
          setLoanB([
            31,
            'GoodLeap',
            12,
            2.99,
            0.0062500000000000000,
            0.0086752000000000000,
            0,
            .26,
            0
          ]),
          setBasePpw(4),
          setPpw(4),
          setRebate(2500),
          setIonRebate(0),
          setPreferredUtility(0)
      }
    }
  }, [austinRebate])

  // console.log(ppw, rebate, rebateSF)

  const cashPrices = [
    { commType: 'Plus', amount: +(+team.cashPpw + .20).toFixed(2), label: 'Plus' },
    { commType: 'Full', amount: +(+team.cashPpw).toFixed(2), label: 'Full' },
    { commType: 'Half', amount: +(team.cashPpw - .20).toFixed(2), label: 'Half' },
    { commType: 'None', amount: +(team.cashPpw - .40).toFixed(2), label: 'Zero' }
  ]

  const prices = [
    { commType: 'Current', amount: +(+ppw).toFixed(2), label: 'Current--' },
    { commType: 'Plus', amount: +(+basePpw + highLoan + .20).toFixed(2), label: 'Plus' },
    { commType: 'Full', amount: +(+basePpw + highLoan).toFixed(2), label: 'Full' },
    { commType: 'Half', amount: +(basePpw + highLoan - .20).toFixed(2), label: 'Half' },
    { commType: 'None', amount: +(basePpw + highLoan - .40).toFixed(2), label: 'Zero' }
  ]

  const virginiaPrices = [
    { commType: 'Current', amount: +(+ppw).toFixed(2), label: 'Current--' },
    { commType: 'Plus', amount: +(+basePpw + highLoan + .20).toFixed(2), label: 'Plus' },
    { commType: 'Full', amount: +(+basePpw + highLoan).toFixed(2), label: 'Full' },
    { commType: 'Half', amount: +(basePpw + highLoan - .15).toFixed(2), label: 'Half' },
    { commType: 'None', amount: +(basePpw + highLoan - .40).toFixed(2), label: 'Zero' }
  ]

  const texasPrices = [
    { commType: 'Current', amount: +(+ppw).toFixed(2), label: 'Current--' },
    { commType: 'Full', amount: +(+basePpw).toFixed(2), label: 'Full' },
    { commType: 'Half', amount: +(basePpw - .20).toFixed(2), label: 'Half' },
    { commType: 'None', amount: +(basePpw - .40).toFixed(2), label: 'Zero' }
  ]

  const texasCPSPrices = [
    { commType: 'Current', amount: +(+ppw).toFixed(2), label: 'Current--' },
    { commType: 'Full', amount: +(+basePpw).toFixed(2), label: 'Full' },
    { commType: 'Half', amount: +(+basePpw - .20).toFixed(2), label: 'Half' },
    { commType: 'None', amount: +(+basePpw - .40).toFixed(2), label: 'Zero' }
  ]

  const vegas2Prices = [
    { commType: 'Current', amount: +(+ppw).toFixed(2), label: 'Current--' },
    { commType: 'Option 1', amount: +(+basePpw + highLoan + .25).toFixed(2), label: 'Option 1' },
    { commType: 'Option 1', amount: +(+basePpw + highLoan).toFixed(2), label: 'Option 2' },
    { commType: 'Option 2', amount: +(+basePpw + highLoan - .25).toFixed(2), label: 'Option 3' },
    { commType: 'Option 3', amount: +(basePpw + highLoan - .50).toFixed(2), label: 'Option 4' },
    { commType: 'Option 4', amount: +(basePpw + highLoan - .75).toFixed(2), label: 'Option 5' },
    { commType: 'Option 5', amount: +(basePpw + highLoan - 1.00).toFixed(2), label: 'Option 6' },
    { commType: 'Option 6', amount: +(basePpw + highLoan - 1.25).toFixed(2), label: 'Option 7' },
    { commType: 'Option 7', amount: +(basePpw + highLoan - 1.50).toFixed(2), label: 'Option 8' }
  ]

  let mappedPrices = prices.map((price, i) => {
    return <MenuItem style={{ display: 'flex', justifyContent: 'space-between', width: '190px' }} key={i} value={+price.amount} onClick={() => { handleClose3(); setPpw(price.amount) }}>
      <span>{price.label}</span>
      <span>{price.amount.toLocaleString(undefined, { style: "currency", currency: "USD" })}/watt</span>
    </MenuItem>
  })

  let mappedCashPrices = cashPrices.map((price, i) => {
    return <MenuItem style={{ display: 'flex', justifyContent: 'space-between', width: '190px' }} key={i} value={+price.amount} onClick={() => { setCashPpw(price.amount); handleClose5() }}>
      <span>{price.label}</span>
      <span>{price.amount.toLocaleString(undefined, { style: "currency", currency: "USD" })}/watt</span>
    </MenuItem>
  })

  let mappedVirginiaPrices = virginiaPrices.map((price, i) => {
    return <MenuItem style={{ display: 'flex', justifyContent: 'space-between', width: '190px' }} key={i} value={+price.amount} onClick={() => { handleClose3(); setPpw(price.amount) }}>
      <span>{price.label}</span>
      <span>{price.amount.toLocaleString(undefined, { style: "currency", currency: "USD" })}/watt</span>
    </MenuItem>
  })

  let mappedTexasPrices = texasCPSPrices.map((price, i) => {
    return <MenuItem style={{ display: 'flex', justifyContent: 'space-between', width: '190px' }} key={i} value={+price.amount} onClick={() => { handleClose3(); setPpw(price.amount) }}>
      <span>{price.label}</span>
      <span>{price.amount.toLocaleString(undefined, { style: "currency", currency: "USD" })}/watt</span>
    </MenuItem>
  })

  let mappedVegas2Prices = vegas2Prices.map((price, i) => {
    return <MenuItem style={{ display: 'flex', justifyContent: 'space-between', width: '190px' }} key={i} value={+price.amount} onClick={() => { handleClose3(); setPpw(price.amount) }}>
      <span>{price.label}</span>
      <span>{price.amount.toLocaleString(undefined, { style: "currency", currency: "USD" })}/watt</span>
    </MenuItem>
  })

  const nestArray = [
    { name: '10%', id: 1 },
    { name: '5%', id: 2 },
    { name: 'N/A', id: 0 }
  ]

  let mappedNest = nestArray.map((nest, i) => {
    return <MenuItem style={{ display: 'flex', justifyContent: 'space-between', width: '190px' }} key={i} value={nest.id} onClick={() => { handleClose4(); setNest(nest.id) }}>
      <span>{nest.name}</span>
    </MenuItem>
  })


  // console.log(ionRebate)

  const repAdder = () => {
    return <>
      {+cpsRebate === 1 || +austinRebate === 1 ? (
        <>
        </>
      ) : (
        <>
          <Button style={{ display: 'flex', justifyContent: 'space-between', width: '100%', height: '60px' }} onClick={e => repAdderToggle(ionRebate, setIonRebate, 1)}> {ionRebate === 1 ? <CheckBoxOutlinedIcon /> : <CheckBoxOutlineBlankOutlinedIcon />} $500 Customer Incentive </Button>
          <Button style={{ display: 'flex', justifyContent: 'space-between', width: '100%', height: '60px' }} onClick={e => repAdderToggle(ionRebate, setIonRebate, 2)}> {ionRebate === 2 ? <CheckBoxOutlinedIcon /> : <CheckBoxOutlineBlankOutlinedIcon />} $500 Rep Incentive </Button>
        </>
      )}
    </>
  }

  const oregonRebate = () => {
    return <>
      {+proposal.rebateOverride > 1 ? (
        <>
          {+hasRebate < 1 || (+hasRebate > 1 && +hasRebate !== 5) ? <Button disabled={+hasRebate === 1 || +hasRebate === 2 || +hasRebate === 3 || +hasRebate === 5} style={{ display: 'flex', justifyContent: 'space-between', width: '100%', height: '60px' }} onClick={e => adderToggleOregon(hasRebate, setHasRebate, 4)}> {+hasRebate === 4 ? <CheckBoxOutlinedIcon /> : <CheckBoxOutlineBlankOutlinedIcon />} ODOE $0.50</Button> : ''}
          {/* {+hasRebate === 1 || +hasRebate === 5 ? <Button disabled={+hasRebate === 0 || +hasRebate === 2 || +hasRebate === 4} style={{ display: 'flex', justifyContent: 'space-between', width: '100%', height: '60px' }} onClick={e => adderToggleOregon(hasRebate, setHasRebate, 3)}> {+hasRebate === 3 || +hasRebate === 5 ? <CheckBoxOutlinedIcon /> : <CheckBoxOutlineBlankOutlinedIcon />} ODOE w/ETO $0.20</Button> : ''} */}
          {+hasRebate < 1 || (+hasRebate > 1 && +hasRebate !== 5) ? <Button disabled={+hasRebate === 1 || +hasRebate === 3 || +hasRebate === 4 || +hasRebate === 5} style={{ display: 'flex', justifyContent: 'space-between', width: '100%', height: '60px' }} onClick={e => adderToggleOregon(hasRebate, setHasRebate, 2)}> {+hasRebate === 2 ? <CheckBoxOutlinedIcon /> : <CheckBoxOutlineBlankOutlinedIcon />} ODOE Low Income $1.80 </Button> : ''}
        </>
      ) : (
        <></>
      )}
    </>
  }

  let signedProp = true;
  if (currentProp) {
    if (customer.step === 'asdfasdf' || customer.step === 'asdfefdfs' || currentProp.contractSigned === false) {
      signedProp = false
    }
  }

  const [viewCashCia, setViewCashCia] = useState(false)

  const ciaButton = () => {
    return currentProp.financingSource === 'Owner Financing' ? <span>*to send loan CIA, sync proposal or create a new one*</span> : <Button disabled={updateCustomer || ciaLoading} variant='outlined' style={{ fontSize: '1.2rem' }} onClick={() => { setCiaLoading(true); sendCia() }}>{ciaLoading ? <CircularProgress size={40} color="inherit" /> : <span>Send Loan CIA</span>} </Button>
  }
  const cashCiaButton = () => {
    return <>
      {viewCashCia ? (
        <>
          <div>
            <Button disabled={updateCustomer || ciaLoading} variant='outlined' style={{ fontSize: '1.2rem' }} onClick={() => { setCiaLoading(true); updateCashCia() }}>{ciaLoading ? <CircularProgress size={40} color="inherit" /> : <span>Send Cash CIA</span>} </Button>
          </div>
          <div>
            <Button disabled={updateCustomer || ciaLoading} variant='outlined' aria-controls="simple-menu" aria-haspopup="true" style={{ fontSize: '1rem' }} onClick={handleClick5}>{ciaLoading ? <CircularProgress size={40} color="inherit" /> : <span>Cash Price: {cashPpw.toLocaleString(undefined, { style: "currency", currency: "USD" })}/watt</span>}
              <ExpandMoreRoundedIcon />
            </Button>
            <Menu
              // onChange={e => setLoanB(e.target.value)}
              id="long-menu"
              anchorEl={anchorCash}
              keepMounted
              open={Boolean(anchorCash)}
              onClose={handleClose5}
            // labelWidth={labelWidth}
            >
              {mappedCashPrices}
            </Menu>
          </div>
        </>
      ) : (
        <>
          <div>
            <Button disabled={updateCustomer || ciaLoading} variant='outlined' style={{ fontSize: '1.2rem' }} onClick={() => { setViewCashCia(true) }}>{ciaLoading ? <CircularProgress size={40} color="inherit" /> : <span>Create Cash CIA</span>} </Button>
          </div>
        </>
      )}
    </>
  }

  const mosaicApi = (method) => {
    axios.post(`https://staging.proposalist.iondeveloper.com/mosaicProposal.php`,
      {
        method: method,
      }).then((res) => {
        // console.log(res.data)
        return [setBundleId(res.data.bundleId), setDisclosures(res.data.disclosures)]
      })
  }


  let mappedProposals = proposals.filter(option => {
    return +option.isActive === 1
  }).map((proposals, i) => {
    const { jan, feb, mar, apr, may, june, july, aug, sept, oct, nov, december } = proposals
    let production = [+jan, +feb, +mar, +apr, +may, +june, +july, +aug, +sept, +oct, +nov, +december]
    let proposalsTotalProduction = total(production)
    let plusMinus = 0
    let commission;
    let batteryType = null
    let eto = 'NO'
    let batteryString = 'Battery'
    let groundMountString = 'Ground Mount'
    let ballastAmount = .20;
    let critterGuardAmount = 0.10;
    let mspAmount = 1500
    let pSolarAmount = .15;
    let battery10Amount = 16000;
    let groundMountAmount = 1.30;

    if (+proposals.ballastAmount > 0) {
      ballastAmount = (+proposals.ballastAmount)
    }
    if (+proposals.critterGuardAmount > 0) {
      critterGuardAmount = (+proposals.critterGuardAmount)
    }
    if (+proposals.mspAmount > 0) {
      mspAmount = (+proposals.mspAmount)
    }
    if (+proposals.pSolarAmount > 0) {
      pSolarAmount = (+proposals.pSolarAmount)
    }
    if (+proposals.battery10Amount > 0) {
      battery10Amount = (+proposals.battery10Amount)
    }
    if (+proposals.groundMountAmount > 0) {
      groundMountAmount = (+proposals.groundMountAmount)
    }

    if (proposals.ogModCount !== proposals.modCount) {
      plusMinus = 1
    }

    let highLoanProp = 0

    if (salesTeam === 'Las Vegas Sales Team') {
      if (proposals.id1 === '32' || proposals.id1 === '45') {
        highLoanProp = .15
      } highLoanProp = 0
    }

    let surveyTypes = []
    if (+proposals.battery10 === 1) {
      surveyTypes.push(batteryString)
    }
    if (+proposals.groundMount === 1) {
      surveyTypes.push(groundMountString)
    }

    let siteSurveyTypes = surveyTypes.concat(surveys)


    if (+proposals.battery10 > 0) {
      batteryType = 'Encharge 10'
    }

    if (proposals.utility === 'Pacific Power' || proposals.utility === 'Portland General Electric (PGE)') {
      if (+proposals.rebateSF > 0) {
        eto = "YES"
      }
    }

    if (proposals.ppw + highLoanProp >= basePpw + highLoanProp + .20) {
      commission = 'Plus'
    }
    else if (proposals.ppw + highLoanProp >= basePpw + highLoanProp && proposals.ppw + highLoanProp < basePpw + highLoanProp + .20) {
      commission = '100%'
    }
    else if (proposals.ppw + highLoanProp >= basePpw + highLoanProp - .20 && proposals.ppw + highLoanProp < basePpw + highLoanProp) {
      commission = '50%'
    } else if (proposals.ppw + highLoanProp < basePpw + highLoanProp - .20) {
      commission = 'None'
    }
    if (proposals.utilityLocation === 'Virginia') {
      commission = ''
    }


    const updateRepProposal = () => {
      axios.post(`https://dev.iondeveloper.com/api/proposal/proposal-tool/?api_key=${process.env.REACT_APP_API_KEY}`, { method: 'update_proposal', id: customer.financeId, id2: customer.designId, id3: customer.projectID, of_Solar_Panels__c: +proposals.modCount, Number_of_Inverters__c: +proposals.modCount, Inverter_Make__c: proposals.invType, Inverter_Model__c: proposals.invModel, Solar_Panel_Make__c: proposals.module, Solar_Panel_Model__c: +proposals.modSize, of_Arrays__c: +proposals.arrayCount, Utility_Rebate__c: +proposals.rebateSF, Primary_Financing_Amount__c: +proposals.loanAmount, System_Size__c: +proposals.systemSize, Secondary_Financing_Amount__c: +proposals.downPayment, Est_Annual_Production__c: +proposalsTotalProduction, jan: +proposals.jan, feb: +proposals.feb, mar: +proposals.mar, apr: +proposals.apr, may: +proposals.may, june: +proposals.june, july: +proposals.july, aug: +proposals.aug, sept: +proposals.sept, oct: +proposals.oct, nov: +proposals.nov, dec: +proposals.december, version: +i + 1, ballast: +proposals.ballast, groundMount: +proposals.groundMount, propId: proposals.propId, Offset__c: offset(), Plus_Minus_Panels__c: plusMinus, Battery_Type__c: batteryType, State_Rebate_Project__c: eto, id4: customer.installId, id5: customer.projectID, of_Stories__c: customer.stories, survey: siteSurveyTypes.join(';'), rep_gen: +proposals.repGen, sharedHome, sharedHome, Financing_Source__c: loanSource, Financing_Product__c: loanProduct, Rebate_Type__c: installRebateType }).then((res) => {
        // console.log(res.data)
        Alert.success(`Proposal info added to App`, {
          position: 'top-right',
          effect: 'flip',
          beep: false,
          timeout: 5000,
          offset: 100,
          color: 'rgba(255, 255, 255, 0.927)'
        })
        getCustomer()
        // setSyncLoading(false)
      })
    }

    const addHomeEnergyAll = () => {
      if (homeEnergyAdderCall.length > 0) {
        axios.post(`https://dev.iondeveloper.com/api/proposal/proposal-tool/?api_key=${process.env.REACT_APP_API_KEY}`, { method: 'add_home_energy_all', financing_id: customer.financeId, project_id: customer.projectID, adders: JSON.stringify(homeEnergyAdderCall) }).then((res) => {
          // console.log(res.data)
          getCustomer()
        })
      }
    }



    let adderCall = [];
    let homeEnergyAdderCall = [];

    let smartHomeCall = {
      adder: 'Smart Home Energy Efficiency Upgrade',
      amount: proposals.smartHomeAmount / 1.28
    }
    let hvacCall = {
      adder: 'HVAC Energy Efficiency Upgrade',
      amount: proposals.hvacAmount / 1.28
    }
    let ledCall = {
      adder: 'LED Lighting',
      amount: proposals.ledAmount / 1.28
    }
    let turfCall = {
      adder: 'Landscaping and Turf Energy Efficiency Upgrade',
      amount: proposals.turfAmount / 1.28
    }
    let windowsCall = {
      adder: 'Windows and Doors Energy Efficiency Upgrade',
      amount: proposals.windowsAmount / 1.28
    }
    let waterCall = {
      adder: 'Water Efficiency Upgrade',
      amount: proposals.waterAmount / 1.28
    }

    if (proposals.smartHome === '1') {
      homeEnergyAdderCall.push(smartHomeCall)
    }
    if (proposals.hvac === '1') {
      homeEnergyAdderCall.push(hvacCall)
    }
    if (proposals.led === '1') {
      homeEnergyAdderCall.push(ledCall)
    }
    if (proposals.turf === '1') {
      homeEnergyAdderCall.push(turfCall)
    }
    if (proposals.windows === '1') {
      homeEnergyAdderCall.push(windowsCall)
    }
    if (proposals.water === '1') {
      homeEnergyAdderCall.push(waterCall)
    }
    let nestType = 'Smart Thermostat'
    if (+proposals.hasNestAdder === 1) {
      nestType = 'Smart Thermostat +'
    }

    let nestTest = {
      adder: "hasNest",
      type: nestType,
      amount: +proposals.hasNest
    }
    let nestCashTest = {
      adder: "hasNestCash"
    }
    let critterGuardTest = {
      adder: "critterGuard",
      amount: (proposals.systemSize * critterGuardAmount)
    }
    let repAdderTest = {
      adder: "repAdder"
    }
    let custAdderTest = {
      adder: "custAdder"
    }
    let custAdderTest1200 = {
      adder: "custAdder1200"
    }
    let sustainableTest = {
      adder: "sustainable"
    }
    let battery10Test = {
      adder: "battery10",
      quantity: +proposals.battery10,
      amount: battery10Amount * dealerFee
    }
    let ballastTest = {
      adder: "ballast",
      amount: ((proposals.ballastModules * proposals.modSize) * ballastAmount)
    }
    let treeRemovalTest = {
      adder: "treeRemoval",
      amount: (proposals.treeTrimAmount * dealerFee)
    }
    let reroofTest = {
      adder: "reroof",
      amount: (proposals.reroofAmount * dealerFee)
    }
    let groundMountTest = {
      adder: "groundMount",
      amount: ((proposals.groundMountModules * proposals.modSize) * groundMountAmount)
    }
    let travelTest = {
      adder: "travel",
      amount: (proposals.systemSize * proposals.travelAmount)
    }
    let pSolarTest = {
      adder: "poolSolar",
      amount: (proposals.systemSize * pSolarAmount)
    }
    let mspTest = {
      adder: "msp",
      amount: mspAmount * dealerFee
    }
    let utahMspTest = {
      adder: "utahMsp",
      amount: mspAmount * dealerFee
    }
    let oregonMspTest = {
      adder: "oregonMsp",
      amount: mspAmount * dealerFee
    }
    let militaryTest = {
      adder: "military",
      amount: proposals.military
    }
    let miscTest = {
      adder: "miscCash",
      amount: proposals.miscCashAmount
    }
    let blackFridayTest = {
      adder: "blackFriday"
    }

    if (+proposals.hasNest > 0) {
      adderCall.push(nestTest)
    }
    // if (proposals.hasNest === '3') {
    //   adderCall.push(nestTest, nestTest)
    // }
    if (proposals.hasNest === '0') {
      adderCall.push(nestCashTest)
    }
    if (proposals.ionRebate === '2') {
      adderCall.push(repAdderTest)
    }
    if (proposals.ionRebate === '1') {
      adderCall.push(custAdderTest)
    }
    if (proposals.ionRebate2 === '1') {
      adderCall.push(custAdderTest1200)
    }
    if (proposals.battery10 > 0) {
      adderCall.push(battery10Test)
    }
    if (proposals.sustainable === '1') {
      adderCall.push(sustainableTest)
    }
    if (proposals.msp === '1') {
      if (proposals.utilityLocation !== 'Utah' && proposals.utilityLocation !== 'Oregon') {
        adderCall.push(mspTest)
      }
      if (proposals.utilityLocation === 'Utah') {
        adderCall.push(utahMspTest)
      }
      if (proposals.utilityLocation === 'Oregon') {
        adderCall.push(oregonMspTest)
      }
    }
    if (proposals.ballast === '1') {
      adderCall.push(ballastTest)
    }
    if (proposals.critterGuard === '1') {
      adderCall.push(critterGuardTest)
    }
    if (proposals.treeTrim === '1') {
      adderCall.push(treeRemovalTest)
    }
    if (proposals.reroof === '1') {
      adderCall.push(reroofTest)
    }
    if (proposals.groundMount === '1') {
      adderCall.push(groundMountTest)
    }
    if (proposals.travel === '1') {
      adderCall.push(travelTest)
    }
    if (proposals.pSolar === '1') {
      adderCall.push(pSolarTest)
    }
    if (+proposals.military > 0) {
      adderCall.push(militaryTest)
    }
    if (proposals.miscCash === '1') {
      adderCall.push(miscTest)
    }
    if (proposals.blackFriday === '1') {
      adderCall.push(blackFridayTest)
    }

    // console.log(utilityLocation)


    let installRebateType;

    if (proposals.utility === 'City Public Service (CPS)' || proposals.utility === 'Colorado Springs Utilities' || proposals.utility === 'Forest Grove Light & Power (FGLP)' || proposals.utility === 'City of San Marcos Utility (SMEU)') {
      installRebateType = 'Inspection'
      eto = "YES"
    }

    if (proposals.utility === 'Pacific Power' || proposals.utility === 'Portland General Electric (PGE)') {
      if (+proposals.rebateSF > 0) {
        installRebateType = 'State Application;State Inspection'
        eto = "YES"
      }
    }




    const offset = () => {
      if (+proposals.hasNest === 1 || +proposals.hasNest === 2) {
        return Math.round((proposalsTotalProduction + +nestAmount) / billCalc[2] * 100)
      } return Math.round((proposalsTotalProduction) / billCalc[2] * 100)
    }
    // console.log(proposals, customer, offset())


    const copier = () => {
      return Alert.success(`${proposals.systemSize / 1000}kW Customer Link Copied`, {
        position: 'top-right',
        effect: 'flip',
        beep: false,
        timeout: 5000,
        offset: 100,
        color: 'rgba(255, 255, 255, 0.927)'
      })
    }

    const deleteProp = () => {
      axios.post(`https://dev.iondeveloper.com/api/proposal/proposal-tool/?api_key=${process.env.REACT_APP_API_KEY}`, { method: 'delete_prop', active: 0, prop_id: proposals.propId }).then((res) => {
        // console.log(res.data)
        getProposalsByProjectId()
        Alert.success(`Proposal Removed`, {
          position: 'top-right',
          effect: 'flip',
          beep: false,
          timeout: 5000,
          offset: 100,
          color: 'rgba(255, 255, 255, 0.927)'
        })
      })
    }

    let custLink;
    if (name) {
      custLink = Math.round(Math.random() * (9999 - 1000) + 1000) + `${name.split(" ").join("")}`
    }
    const propV = i + 1


    const syncProp = () => {
      axios.post(`https://dev.iondeveloper.com/api/proposal/proposal-tool/?api_key=${process.env.REACT_APP_API_KEY}`, { method: 'sync_prop', sync: 1, prop_id: proposals.propId }).then((res) => {
        // console.log(res.data)

      })
    }

    let synced = false
    let syncedId
    if (currentProp) {
      syncedId = currentProp.syncPropId
    }
    if (proposals.propId === syncedId) {
      synced = true
    }





    return <div key={i}>
      <div >
        {viewCiaInfo ? (
          <>
            <Button disabled={signedProp || syncLoading === true} onClick={() => { updateRepProposal(); syncProp(); addHomeEnergyAll(); setSyncLoading(true) }} style={{ display: 'flex', justifyContent: 'space-between', width: '100%', height: '50px' }}  >{synced ? <CheckBoxOutlinedIcon /> : syncLoading === true ? <CircularProgress size={35} color="inherit" /> : <CheckBoxOutlineBlankOutlinedIcon />} v{i + 1}
              <span>{proposals.systemSize / 1000} kW</span>
              <span> {proposals.utility === 'Austin Energy' || proposals.utility === 'City of Fort Collins Utilities (FCU)' ? ((+proposals.loanAmount).toLocaleString(undefined, { style: "currency", currency: "USD" })) : (+proposals.loanAmount + +proposals.rebate + +proposals.downPayment).toLocaleString(undefined, { style: "currency", currency: "USD" })}</span>
              {uType === 'Square Footage' ? '' : <span>{offset()}%</span>}
            </Button>
          </>
        ) : viewProposals === true ? (
          <>
            <Link target='_blank' to={`/proposalview/${proposals.propId}/${i + 1}/1`}>
              <Button style={{ display: 'flex', justifyContent: 'space-between', width: '100%', height: '50px' }}  > v{i + 1}
                <span>{proposals.systemSize / 1000} kW</span>
                <span> {proposals.utility === 'Austin Energy' || proposals.utility === 'City of Fort Collins Utilities (FCU)' ? ((+proposals.loanAmount).toLocaleString(undefined, { style: "currency", currency: "USD" })) : (+proposals.loanAmount + +proposals.rebate + +proposals.downPayment).toLocaleString(undefined, { style: "currency", currency: "USD" })}</span>
                {uType === 'Square Footage' ? '' : <span>{offset()}%</span>}
              </Button>
            </Link>
            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
              <CopyToClipboard onCopy={() => { setCopied(true); copier() }} text={`https://proposalist.iondeveloper.com/?proj_id=${proposal.projectId}#/customerproposalview/${proposals.propId}/${i + 1}/${custLink}`}>
                <Button> Customer Link</Button>
              </CopyToClipboard>
              {/* <a href={`https://dev.iondeveloper.com/api/fieldpro/generatePDF/proposal.php?projectId=${proposals.projectId}&propId=${proposals.propId}`} target='_blank'>
                <IconButton style={{ color: 'black' }} >
                  <GetAppRoundedIcon />
                </IconButton>
              </a> */}
              {signedProp === false ? (
                <>
                  {synced ? (
                    <>
                      <IconButton style={{ color: 'black' }}  ><CheckCircleOutlineRoundedIcon /></IconButton>
                    </>
                  ) : synced ? <CheckBoxOutlinedIcon /> : syncLoading === true ? <CircularProgress size={30} color="inherit" /> : (
                    <IconButton style={{ color: 'black' }} onClick={() => { updateRepProposal(); syncProp(); addHomeEnergyAll(); setSyncLoading(true) }} ><SyncRoundedIcon /></IconButton>
                  )}
                  {synced ? (
                    <IconButton>
                      <DeleteIcon color="disabled" />
                    </IconButton>
                  ) : (
                    <IconButton style={{ color: 'rgb(130, 48, 48)' }} onClick={() => deleteProp()}>
                      <DeleteIcon />
                    </IconButton>
                  )}
                </>
              ) : (
                <>
                </>
              )}
            </div>
          </>
        ) : (
          <>
          </>
        )}
        <div style={{ display: 'flex', justifyContent: synced ? 'space-between' : 'flex-end', borderBottom: '1px dashed black', marginLeft: '8px', marginRight: '8px', fontSize: '.8rem' }}>
          {synced ? <span>CURRENT</span> : ''}
          <span>PROPOSAL ID - {proposals.propId}</span>
        </div>

      </div>
    </div>
  })

  const viewA = () => {
    setViewAdders(!viewAdders)
    setViewEquipment(false)
    setViewLoans(false)
    setViewProposals(false)
    setViewCiaInfo(false)
    setQualify(false)
    setAgree(false)
    setAgreed(false)
  }

  const viewE = () => {
    setViewEquipment(!viewEquipment)
    setViewAdders(false)
    setViewLoans(false)
    setViewProposals(false)
    setViewCiaInfo(false)
    setQualify(false)
    setAgree(false)
    setAgreed(false)
  }

  const viewL = () => {
    setViewLoans(!viewLoans)
    setViewEquipment(false)
    setViewAdders(false)
    setViewProposals(false)
    setViewCiaInfo(false)
    setQualify(false)
    setAgree(false)
    setAgreed(false)
  }

  const viewP = () => {
    setViewProposals(!viewProposals)
    setViewLoans(false)
    setViewEquipment(false)
    setViewAdders(false)
    setViewCiaInfo(false)
    setQualify(false)
    setAgree(false)
    setAgreed(false)
  }

  const viewApp = () => {
    setViewProposals(false)
    setViewLoans(false)
    setViewEquipment(false)
    setViewAdders(false)
    setQualify(false)
    setAgree(false)
    setAgreed(false)
    setViewCiaInfo(!viewCiaInfo)

  }

  const closeSlider = () => {
    setViewProposals(false)
    setViewCiaInfo(false)
    setViewLoans(false)
    setViewEquipment(false)
    setViewAdders(false)
    setViewNest(false)
    setViewCustomer(false)
    setQualify(false)
    setAgree(false)
    setAgreed(false)
  }

  let oregonLabel = 'Energy Trust Incentive'
  if (+hasRebate === 3 || +hasRebate === 5) {
    oregonLabel = 'ETO + ODOE Rebate'
  }
  if (+hasRebate === 2 || +hasRebate === 4) {
    oregonLabel = 'ODOE Rebate'
  }

  const mosaicCredit = () => {
    return <> {
      loanA[1] === 'Mosaic' || loanB[1] === 'Mosaic' ? (
        <>
          <Button onClick={() => { setQualify(!qualify); mosaicApi('disclosures') }} style={{ display: 'flex', justifyContent: 'space-between', width: '100%', height: '70px' }}>
            <span style={{ fontSize: '1.2rem' }}>Qualify</span>
          </Button>
        </>
      ) : (
        <>
        </>
      )
    }
    </>
  }

  // console.log(name)
  return (
    <>
      {/* {+proposal.isActive === 1 && +view === 1 ? (
        <> */}

      <div className='body' >
        {/* //make sure to comment all of this out  below */}
        <div >
          <div className={+view !== 1 ? 'hiddenMenu noDisplay' : 'hiddenMenu'}>
            <MenuRoundedIcon className='slider' style={{ color: 'black' }} fontSize="large" onClick={() => setSlider(!slider)} />
          </div>
          <div className={slider ? 'sideMenu slide' : 'sideMenu'}>
            <div className='menus' >
              <Button onClick={() => { setSlider(!slider); closeSlider() }} style={{ display: 'flex', justifyContent: 'baseline', width: '100%', height: '70px' }}>
                {/* <div className='phoneArrow'>
                  <ArrowBackIosIcon />
                </div> */}
                {name ? (<><h2 style={{ fontWeight: 'initial' }} >{name.toUpperCase()}</h2></>) : (<></>)}
              </Button>
              <div className='phoneView'>
                <span className={+view !== 1 ? ' noDisplay' : ''}>${Math.round(systemCost).toLocaleString(undefined)} - </span>
                <span>{systemSize / 1000}kW - </span>
                <span className={uType === 'Square Footage' ? ' noDisplay' : ''}>{Math.round((totalProduction / +totalUsage * 100))}%</span>
              </div>
              <span className={+view === 1 ? ' noDisplay' : ''}>Please rotate landscape or open on a <br /> desktop/larger device to view full proposal.</span>
              <div className='phoneView'>
                <div className={+view === 1 ? 'phoneDesign noDisplay' : 'phoneDesign'} style={{ backgroundImage: `url(${design})` }}></div>
                <span>Proposal ID - {proposal.propId}</span>
              </div>
              <div className={+view !== 1 ? 'menuButtons noDisplay' : 'menuButtons'}>
                <Button onClick={handleClick3} aria-controls="simple-menu" aria-haspopup="true" style={{ display: 'flex', justifyContent: 'space-between', width: '100%', height: '70px' }}>
                  <AttachMoneyRoundedIcon />
                  <span style={{ fontSize: '1.2rem' }}>Pricing</span>
                </Button>
                <Menu
                  onChange={e => setPpw(+e.target.value)}
                  id="long-menu"
                  anchorEl={anchorPricing}
                  keepMounted
                  open={Boolean(anchorPricing)}
                  onClose={handleClose3}
                // labelWidth={labelWidth}
                >
                  {
                    austinRebate === 1 || cpsRebate === 1 ? (
                      mappedTexasPrices
                    ) :
                      utilityLocation === 'Virginia' ? (
                        mappedVirginiaPrices
                      ) : salesTeam === 'Las Vegas Sales Team II' || salesTeam === 'Las Vegas Sales Team 3' ? (
                        mappedVegas2Prices
                      ) : (
                        mappedPrices
                      )}
                </Menu>
                <Button onClick={() => viewA()} style={{ display: 'flex', justifyContent: 'space-between', width: '100%', height: '70px' }}>
                  <AddRoundedIcon />
                  <span style={{ fontSize: '1.2rem' }}>Adders</span>
                </Button>
                <Button onClick={() => viewE()} style={{ display: 'flex', justifyContent: 'space-between', width: '100%', height: '70px' }}>
                  <FlashOnRoundedIcon />
                  <span style={{ fontSize: '1.2rem' }}>Equipment</span>
                </Button>
                <Button onClick={() => viewL()} style={{ display: 'flex', justifyContent: 'space-between', width: '100%', height: '70px' }}>
                  <EqualizerRoundedIcon />
                  <span style={{ fontSize: '1.2rem' }}>Financing</span>
                </Button>
                <Button onClick={() => viewApp()} style={{ display: 'flex', justifyContent: 'space-between', width: '100%', height: '70px' }}>
                  <MailOutlineRoundedIcon />
                  <span style={{ fontSize: '1.2rem' }}>Send CIA</span>
                </Button>
                {/* <Button onClick={() => createProposal()} style={{ display: 'flex', justifyContent: 'space-between', width: '100%', height: '70px' }} >
                  <SaveRoundedIcon />
                  <span style={{ fontSize: '1.2rem' }}>Create New Proposal</span>
                </Button> */}
                <Button disabled={loading} onClick={() => { buildNewProposal() }} style={{ display: 'flex', justifyContent: 'space-between', width: '100%', height: '70px' }} >
                  <SaveRoundedIcon />
                  {loading ? <CircularProgress size={50} color="inherit" /> : <span style={{ fontSize: '1.2rem' }}>Create New Proposal</span>}
                </Button>
                <Button onClick={() => viewP()} style={{ display: 'flex', justifyContent: 'space-between', width: '100%', height: '70px' }}>
                  <ListAltRoundedIcon />
                  <span style={{ fontSize: '1.2rem' }}>Proposals</span>
                </Button>
              </div>
              <div >
                <img src="//ionsolar.com/wp-content/themes/ion-solar/assets/img/ion_square.png" ></img>
              </div>
            </div>
            <a target='_blank' href={`https://proposalist.iondeveloper.com/?proj_id=${customer.projectID}#/propview/${proposal.propId}/3/1`}>
              <span>Version 2 View</span>
            </a>
            <span>Proposal ID - {proposal.propId}</span>
            <span>{user}</span>
          </div>
          <div className={viewEquipment === true ? 'equipmentMenu slideEquipment' : 'equipmentMenu'}>
            <Button onClick={() => setViewEquipment(!viewEquipment)} style={{ display: 'flex', justifyContent: 'space-between', width: '100%', height: '70px' }}>
              <span style={{ fontSize: '1.2rem' }}>Equipment</span>
              <FlashOnRoundedIcon />
            </Button>
            {/* <div className='phonePanels'> */}
            {view === `1` ? (
              panelAmount === +maxModCount || proposal.maxOffset && (totalProduction / totalUsage) * 100 >= (+proposal.maxOffset * .97) || +proposal.groundMount === 1 ? <ArrowUpwardRoundedIcon fontSize="large" color='disabled' /> : <ArrowUpwardRoundedIcon fontSize="large" onClick={() => addPanel()} />
            ) : (
              <>
              </>
            )}
            {view === `1` ? (
              panelAmount === 7 || +proposal.groundMount === 1 ? <ArrowDownwardRoundedIcon fontSize="large" color='disabled' /> : <ArrowDownwardRoundedIcon fontSize="large" onClick={() => removePanel()} />
            ) : (
              <>
              </>
            )}
            {/* </div> */}
            <Button
              // onClick={handleClick}
              aria-controls="simple-menu" aria-haspopup="true" style={{ display: 'flex', justifyContent: 'space-between', width: '100%', height: '70px' }}>
              <ViewModuleRoundedIcon />
              <span style={{ fontSize: '1.2rem' }}>{panelAmount} {mod[1]} {mod[2]} {mod[3]}</span>
            </Button>
            <Button
              // onClick={handleClick}
              aria-controls="simple-menu" aria-haspopup="true" style={{ display: 'flex', justifyContent: 'space-between', width: '100%', height: '70px' }}>
              <SettingsInputComponentRoundedIcon />
              <span style={{ fontSize: '1.2rem' }}>{invType} IQ</span>
            </Button>
          </div>
          <div className={qualify === true ? 'qualifyMenu slideQualifying' : 'qualifyMenu'}>
            {name ? (
              <MosaicCredit
                view={view}
                projectId={customer.projectID}
                agree={agree}
                agreed={agreed}
                setAgree={setAgree}
                setAgreed={setAgreed}
                bundleId={bundleId}
                disclosures={disclosures}
                name={name}
                projectID={customer.projectID}
                email={customer.email}
                repEmail={customer.repEmail}
                phone={phone}
                street={street}
                city={city}
                state={state}
                zip={zip}
                getCustomer={getCustomer}
                setUpdateCustomer={setUpdateCustomer}
                updateCustomer={updateCustomer}
              />
            ) : (
              <>
              </>
            )}
          </div>
          <div className={viewCustomer === true ? 'customerMenu slideCustomer' : 'customerMenu'}>
            <Button onClick={() => setViewCustomer(!viewCustomer)} style={{ display: 'flex', justifyContent: 'space-between', width: '100%', height: '70px' }}>
              <span style={{ fontSize: '1.2rem' }}>Customer Information</span>
              <BorderColorRoundedIcon />
            </Button>
            {name ? <UpdateCustomer
              name={name}
              projectID={customer.projectID}
              email={customer.email}
              phone={phone}
              street={street}
              city={city}
              state={state}
              zip={zip}
              getCustomer={getCustomer}
              setUpdateCustomer={setUpdateCustomer}
              updateCustomer={updateCustomer}
              setViewCustomer={setViewCustomer}
              viewCustomer={viewCustomer}
            /> : null}

          </div>
          <div className={viewLoans === true ? 'addersMenu slideAdders' : 'addersMenu'}>
            <Button onClick={() => setViewLoans(!viewLoans)} style={{ display: 'flex', justifyContent: 'space-between', width: '100%', height: '70px' }}>
              <span style={{ fontSize: '1.2rem' }}>Financing</span>
              <EqualizerRoundedIcon />
            </Button>
            {custUtility === 'City Public Service (CPS)' ? <Button style={{ display: 'flex', justifyContent: 'space-between', width: '100%', height: '70px' }} onClick={e => adderToggle(cpsRebate, setCpsRebate)}>{cpsRebate ? <CheckBoxOutlinedIcon /> : <CheckBoxOutlineBlankOutlinedIcon />}CPS Rebate</Button> : custUtility === 'Austin Energy' ? <Button style={{ display: 'flex', justifyContent: 'space-between', width: '100%', height: '70px' }} onClick={e => adderToggle(austinRebate, setAustinRebate)}>{austinRebate ? <CheckBoxOutlinedIcon /> : <CheckBoxOutlineBlankOutlinedIcon />}Austin Rebate</Button> : ''}
            {/* {utilityLocation === 'Oregon' ? oregonRebate() : ''} */}
            <div>
              <Button onClick={handleClick1} aria-controls="simple-menu" aria-haspopup="true" style={{ display: 'flex', justifyContent: 'space-between', width: '100%', height: '70px' }}>
                <ExpandMoreRoundedIcon />
                <span style={{ fontSize: '1.2rem', textDecoration: 'none' }}>Option 1</span>
              </Button>
              <Menu
                onChange={e => setLoanA(e.target.value)}
                id="long-menu"
                anchorEl={anchorLoan1}
                keepMounted
                open={Boolean(anchorLoan1)}
                onClose={handleClose1}
              // labelWidth={labelWidth}
              >
                {mappedLoans}
              </Menu>
              {creditCheck()}
            </div>
            <div>
              <Button onClick={handleClick2} aria-controls="simple-menu" aria-haspopup="true" style={{ display: 'flex', justifyContent: 'space-between', width: '100%', height: '70px' }}>
                <ExpandMoreRoundedIcon />
                <span style={{ fontSize: '1.2rem', textDecoration: 'none' }}>Option 2</span>
              </Button>
              <Menu
                // onChange={e => setLoanB(e.target.value)}
                id="long-menu"
                anchorEl={anchorLoan2}
                keepMounted
                open={Boolean(anchorLoan2)}
                onClose={handleClose2}
              // labelWidth={labelWidth}
              >
                {mappedLoans2}
              </Menu>
              {creditCheck2()}
            </div>
            {mosaicCredit()}
          </div>
          <div className={viewAdders === true ? 'addersMenu slideAdders' : 'addersMenu'} >
            <Button onClick={() => setViewAdders(!viewAdders)} style={{ display: 'flex', justifyContent: 'space-between', width: '100%', height: '70px' }}>
              <span style={{ fontSize: '1.2rem' }}>Adders</span>
              <AddRoundedIcon />
            </Button>
            <div style={{ overflow: 'scroll' }}>
              <Button style={{ display: 'flex', justifyContent: 'space-between', width: '100%', height: '70px' }} onClick={e => { adderToggleNest(nest, setNest) }}>{nest ? <CheckBoxOutlinedIcon /> : <CheckBoxOutlineBlankOutlinedIcon />}Smart Thermostat & Bulbs<br /> (Uncheck to cash out)</Button>
              {nest > 0 ? (
                <>
                  <FormControl fullWidth>
                    <InputLabel id="demo-simple-select-label" ># of Nests</InputLabel>
                    <Select
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      value={nest}
                      onChange={handleChangeNest}

                    >
                      <MenuItem value={1}>1</MenuItem>
                      <MenuItem value={3}>2</MenuItem>
                    </Select>
                  </FormControl>
                </>
              ) : (
                <>
                </>
              )}
              {utilityLocation === 'Virginia' ? (
                <>
                  {nest > 0 ? (
                    <>
                      <Button style={{ display: 'flex', justifyContent: 'space-between', width: '100%', height: '70px' }} onClick={e => adderToggle(nestAdder, setNestAdder)}>{nestAdder ? <CheckBoxOutlinedIcon /> : <CheckBoxOutlineBlankOutlinedIcon />}VA Nest</Button>
                    </>
                  ) : (
                    <>
                      <Button disabled style={{ display: 'flex', justifyContent: 'space-between', width: '100%', height: '70px' }} >{nestAdder && nest ? <CheckBoxOutlinedIcon /> : <CheckBoxOutlineBlankOutlinedIcon />}VA Nest</Button>
                    </>
                  )}
                </>
              ) : (
                <>
                </>
              )}
              {repAdder()}
              <Button style={{ display: 'flex', justifyContent: 'space-between', width: '100%', height: '60px' }} onClick={e => adderToggle(miscCash, setMiscCash)}>{miscCash ? <CheckBoxOutlinedIcon /> : <CheckBoxOutlineBlankOutlinedIcon />}MISC Cash <br />(not for nest cash out)</Button>
              {miscCash ? <> <TextField fullWidth label="MISC Cash Amount" variant="filled" type='number' size="small" margin="dense" value={miscCashAmount} InputProps={{
                inputProps: { inputMode: 'numeric', pattern: '[0-9]*' },
                startAdornment: (
                  <InputAdornment position="start">
                    <AttachMoneyRoundedIcon />
                  </InputAdornment>
                ),
              }} onChange={e => setMiscCashAmount(e.target.value)}></TextField>
                <TextField fullWidth label="MISC Cash Notes" variant="filled" size="small" margin="dense" inputProps={{ maxLength: 100 }} value={miscCashNotes} onChange={e => setMiscCashNotes(e.target.value)}></TextField> </> : ''}
              {+proposal.groundMount === 1 ? <Button style={{ display: 'flex', justifyContent: 'space-between', width: '100%', height: '60px' }} > <CheckBoxOutlinedIcon /> Ground Mount</Button> : ''}
              <Button style={{ display: 'flex', justifyContent: 'space-between', width: '100%', height: '60px' }} onClick={e => adderToggle(msp, setMsp)}>{msp ? <CheckBoxOutlinedIcon /> : <CheckBoxOutlineBlankOutlinedIcon />}MSP Upgrade</Button>
              <Button style={{ display: 'flex', justifyContent: 'space-between', width: '100%', height: '60px' }} onClick={e => adderToggle(critterGuard, setCritterGuard)}>{critterGuard ? <CheckBoxOutlinedIcon /> : <CheckBoxOutlineBlankOutlinedIcon />}Critter Guards</Button>
              <Button style={{ display: 'flex', justifyContent: 'space-between', width: '100%', height: '60px' }} onClick={e => adderToggle(military, setMilitary)}>{military ? <CheckBoxOutlinedIcon /> : <CheckBoxOutlineBlankOutlinedIcon />}Military Discount</Button>
              {military ? (
                <>
                  <FormControl fullWidth>
                    <InputLabel id="demo-simple-select-label" >Amount</InputLabel>
                    <Select
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      value={military}
                      onChange={handleChangeMilitary}

                    >
                      <MenuItem value={1}>$250</MenuItem>
                      <MenuItem value={2}>$500</MenuItem>
                    </Select>
                  </FormControl>
                </>
              ) : (
                <>
                </>
              )}
              {utilityLocation === 'Texas' || utilityLocation === 'asdf' ? (
                <>
                  <Button style={{ display: 'flex', justifyContent: 'space-between', width: '100%', height: '70px' }} onClick={e => adderToggleBattery(battery10, setBattery10)}>{battery10 ? <CheckBoxOutlinedIcon /> : <CheckBoxOutlineBlankOutlinedIcon />}<span >Encharge10 Battery</span>
                  </Button>
                  {battery10 ? (
                    <>
                      <FormControl fullWidth>
                        <InputLabel id="demo-simple-select-label"># of batteries</InputLabel>
                        <Select
                          labelId="demo-simple-select-label"
                          id="demo-simple-select"
                          value={battery10}
                          onChange={handleChangeBattery}
                        >
                          <MenuItem value={1}>1</MenuItem>
                          <MenuItem value={2}>2</MenuItem>
                          <MenuItem value={3}>3</MenuItem>
                          <MenuItem value={4}>4</MenuItem>
                          <MenuItem value={5}>5</MenuItem>
                          <MenuItem value={6}>6</MenuItem>
                          <MenuItem value={7}>7</MenuItem>
                          <MenuItem value={8}>8</MenuItem>
                          <MenuItem value={9}>9</MenuItem>
                          <MenuItem value={10}>10</MenuItem>
                        </Select>
                      </FormControl>
                    </>
                  ) : (
                    <>
                    </>
                  )}
                </>
              ) : (
                <>
                </>
              )}




              {/* <Button style={{ display: 'flex', justifyContent: 'space-between', width: '100%', height: '60px' }} onClick={e => adderToggle(blackFriday, setBlackFriday)}>{blackFriday ? <CheckBoxOutlinedIcon /> : <CheckBoxOutlineBlankOutlinedIcon />}Black Friday</Button> */}

              {/* {utilityLocation === 'Oregon' ? (
            <>
              <Button style={{ display: 'flex', justifyContent: 'space-between', width: '100%', height: '60px' }} onClick={e => adderToggle(sustainable, setSustainable)}>{sustainable ? <CheckBoxOutlinedIcon /> : <CheckBoxOutlineBlankOutlinedIcon />}Sustainable Great</Button>
            </>
          ) : (
              <>
              </>
            )} */}
              {hasRebate === '1' ? (
                <>
                  <Button style={{ display: 'flex', justifyContent: 'space-between', width: '100%', height: '60px' }}>
                    <span style={{ fontSize: '1.2rem' }}>Discounts</span>
                    <AttachMoneyRoundedIcon />
                  </Button>
                  <Button disabled style={{ display: 'flex', justifyContent: 'space-between', width: '100%', height: '60px' }} onClick={e => adderToggle(preferredUtility, setPreferredUtility)}> {preferredUtility ? <CheckBoxOutlinedIcon /> : <CheckBoxOutlineBlankOutlinedIcon />} "Preferred Utility Discount" </Button>
                  {preferredUtility === 1 || referral === 1 ? (
                    <>
                      <Button disabled style={{ display: 'flex', justifyContent: 'space-between', width: '100%', height: '60px' }} onClick={e => adderToggle(sameDay, setSameDay)}> {sameDay ? <CheckBoxOutlinedIcon /> : <CheckBoxOutlineBlankOutlinedIcon />} "$1,000 Same Day" </Button>
                    </>
                  ) : (
                    <>
                      <Button style={{ display: 'flex', justifyContent: 'space-between', width: '100%', height: '60px' }} onClick={e => adderToggle(sameDay, setSameDay)}> {sameDay ? <CheckBoxOutlinedIcon /> : <CheckBoxOutlineBlankOutlinedIcon />} "$1,000 Same Day" </Button>
                    </>
                  )}
                  {preferredUtility === 1 || sameDay === 1 ? (
                    <>
                      <Button disabled style={{ display: 'flex', justifyContent: 'space-between', width: '100%', height: '60px' }} onClick={e => adderToggle(referral, setReferral)}> {referral ? <CheckBoxOutlinedIcon /> : <CheckBoxOutlineBlankOutlinedIcon />} "$1,500 Referral" </Button>
                    </>
                  ) : (
                    <>
                      <Button style={{ display: 'flex', justifyContent: 'space-between', width: '100%', height: '60px' }} onClick={e => adderToggle(referral, setReferral)}> {referral ? <CheckBoxOutlinedIcon /> : <CheckBoxOutlineBlankOutlinedIcon />} "$1,500 Referral" </Button>
                    </>
                  )}
                </>
              ) : (
                <>
                  <Button style={{ display: 'flex', justifyContent: 'space-between', width: '100%', height: '60px' }}>
                    <span style={{ fontSize: '1.2rem' }}>Discounts</span>
                    <AttachMoneyRoundedIcon />
                  </Button>
                  {hasRebate === '1' ? (
                    <>
                      {preferredUtility === 1 || referral === 1 ? (
                        <>
                          <Button disabled style={{ display: 'flex', justifyContent: 'space-between', width: '100%', height: '60px' }} onClick={e => adderToggle(sameDay, setSameDay)}> {sameDay ? <CheckBoxOutlinedIcon /> : <CheckBoxOutlineBlankOutlinedIcon />} "$1,000 Same Day" </Button>
                        </>
                      ) : (
                        <>
                          <Button style={{ display: 'flex', justifyContent: 'space-between', width: '100%', height: '60px' }} onClick={e => adderToggle(sameDay, setSameDay)}> {sameDay ? <CheckBoxOutlinedIcon /> : <CheckBoxOutlineBlankOutlinedIcon />} "$1,000 Same Day" </Button>
                        </>
                      )}
                      {preferredUtility === 1 || sameDay === 1 ? (
                        <>
                          <Button disabled style={{ display: 'flex', justifyContent: 'space-between', width: '100%', height: '60px' }} onClick={e => adderToggle(referral, setReferral)}> {referral ? <CheckBoxOutlinedIcon /> : <CheckBoxOutlineBlankOutlinedIcon />} "$1,500 Referral" </Button>
                        </>
                      ) : (
                        <>
                          <Button style={{ display: 'flex', justifyContent: 'space-between', width: '100%', height: '60px' }} onClick={e => adderToggle(referral, setReferral)}> {referral ? <CheckBoxOutlinedIcon /> : <CheckBoxOutlineBlankOutlinedIcon />} "$1,500 Referral" </Button>
                        </>
                      )}
                    </>
                  ) : (
                    <>
                      {sameDay === 1 || referral === 1 ? (

                        <Button disabled style={{ display: 'flex', justifyContent: 'space-between', width: '100%', height: '60px' }} onClick={e => adderToggle(preferredUtility, setPreferredUtility)}> {preferredUtility ? <CheckBoxOutlinedIcon /> : <CheckBoxOutlineBlankOutlinedIcon />} "Preferred Utility Discount" </Button>

                      ) : (

                        <Button style={{ display: 'flex', justifyContent: 'space-between', width: '100%', height: '60px' }} onClick={e => adderToggle(preferredUtility, setPreferredUtility)}> {preferredUtility ? <CheckBoxOutlinedIcon /> : <CheckBoxOutlineBlankOutlinedIcon />} "Preferred Utility Discount" </Button>
                      )}
                      {preferredUtility === 1 || referral === 1 ? (
                        <>
                          <Button disabled style={{ display: 'flex', justifyContent: 'space-between', width: '100%', height: '60px' }} onClick={e => adderToggle(sameDay, setSameDay)}> {sameDay ? <CheckBoxOutlinedIcon /> : <CheckBoxOutlineBlankOutlinedIcon />} "$1,000 Same Day" </Button>
                        </>
                      ) : (
                        <>
                          <Button style={{ display: 'flex', justifyContent: 'space-between', width: '100%', height: '60px' }} onClick={e => adderToggle(sameDay, setSameDay)}> {sameDay ? <CheckBoxOutlinedIcon /> : <CheckBoxOutlineBlankOutlinedIcon />} "$1,000 Same Day" </Button>
                        </>
                      )}
                      {preferredUtility === 1 || sameDay === 1 ? (
                        <>
                          <Button disabled style={{ display: 'flex', justifyContent: 'space-between', width: '100%', height: '60px' }} onClick={e => adderToggle(referral, setReferral)}> {referral ? <CheckBoxOutlinedIcon /> : <CheckBoxOutlineBlankOutlinedIcon />} "$1,500 Referral" </Button>
                        </>
                      ) : (
                        <>
                          <Button style={{ display: 'flex', justifyContent: 'space-between', width: '100%', height: '60px' }} onClick={e => adderToggle(referral, setReferral)}> {referral ? <CheckBoxOutlinedIcon /> : <CheckBoxOutlineBlankOutlinedIcon />} "$1,500 Referral" </Button>
                        </>
                      )}
                    </>
                  )}
                </>
              )}


              {/* <Button style={{ display: 'flex', justifyContent: 'space-between', width: '100%', height: '70px' }} onClick={e => adderToggle(ballast, setBallast)}>{ballast ? <CheckBoxOutlinedIcon /> : <CheckBoxOutlineBlankOutlinedIcon />}Ballast Mounts</Button> */}
            </div>
          </div>
          <div className={viewCiaInfo === true ? 'ciaMenu slideAdders' : 'ciaMenu'}>
            <Button onClick={() => setViewCiaInfo(!viewCiaInfo)} style={{ display: 'flex', justifyContent: 'space-between', width: '100%', height: '70px' }}>
              <span style={{ fontSize: '1.2rem' }}>CIA</span>
              <MailOutlineRoundedIcon />
            </Button>
            {currentProp ? (
              <div className='ciaInside'>
                <div className={updateCustomer === true ? 'ciaLeft ciaLeftUpdate' : 'ciaLeft'}>
                  {updateCustomer === true ? (
                    <>
                      <UpdateCustomer
                        name={name}
                        projectID={customer.projectID}
                        email={customer.email}
                        phone={phone}
                        street={street}
                        city={city}
                        state={state}
                        zip={zip}
                        getCustomer={getCustomer}
                        setUpdateCustomer={setUpdateCustomer}
                        updateCustomer={updateCustomer}
                      />
                    </>
                  ) : (
                    <>
                      <div>
                        <span>{name}</span>
                      </div>
                      <div>
                        <span>{phone}</span>
                      </div>
                      <div>
                        <span>{customer.email}</span>
                      </div>
                      <div>
                        <span>{street}, {city}, {state} {zip}</span>
                      </div>
                      <div>
                        <Button variant='outlined' style={{ fontSize: '.8rem' }} onClick={() => setUpdateCustomer(!updateCustomer)}  >Edit Customer Info</Button>
                      </div>

                      <div>
                        <span>------------------------------</span>
                      </div>
                      <div>
                        {/* {currentProp.financingSource === 'Owner Financing' ? <span>CASH</span> : <span>LOAN</span>} */}
                      </div>
                      <div>
                        {financingLabel()}
                        <span>{(+currentProp.financingAmount).toLocaleString(undefined, { style: "currency", currency: "USD" })}</span>
                      </div>
                      <div>
                        <span style={{ fontWeight: 'bold' }} >Rebate: </span>
                        <span>{(+currentProp.rebate).toLocaleString(undefined, { style: "currency", currency: "USD" })}</span>
                      </div>
                      <div>
                        <span style={{ fontWeight: 'bold' }}>Panel Amount: </span>
                        <span>{Math.round(currentProp.panelAmount)} {currentProp.panel}</span>
                      </div>
                      <div>
                        <span style={{ fontWeight: 'bold' }}>System Size: </span>
                        <span>{currentProp.systemSize / 1000}kW</span>
                      </div>
                      <div>
                        {currentProp.syncPropId ? (
                          <>
                            <span style={{ fontWeight: 'bold' }}>Proposal ID: </span>
                            <span>{currentProp.syncPropId}</span>
                          </>
                        ) : (
                          <>
                          </>
                        )}
                      </div>
                      <div>
                        {/* <span>------------------------------</span> */}
                      </div>
                      <div>
                        <span>------------------------------</span>
                      </div>
                      <div>
                        <span style={{ fontSize: '1.2rem', fontWeight: 'bold' }} >Incentives:</span>
                      </div>
                      {mappedAdders}
                    </>
                  )}
                </div>
                <div className='ciaRight'>
                  <span style={{ fontWeight: 'bold' }}>Select Proposal for CIA</span>
                  {mappedProposals}
                </div>
                <div>
                  <span>Verify the customer information before sending the agreement</span>
                </div>

                <div>
                  <Button variant='outlined' style={{ fontSize: '.8rem' }} onClick={() => setUpdateCustomer(!updateCustomer)}  >Edit Customer Info</Button>
                </div>
                <div>
                  {ciaButton()}
                </div>
                <div>
                  {cashCiaButton()}
                </div>

              </div>
            ) : (
              <>
              </>
            )}
          </div>
          <div className={viewProposals === true ? 'proposalsMenu slideProposals' : 'proposalsMenu'}>
            <div>
              <Button onClick={() => setViewProposals(!viewProposals)} style={{ display: 'flex', justifyContent: 'space-between', width: '100%', height: '70px' }}>
                <span style={{ fontSize: '1.2rem' }}>Proposals</span>
                <ListAltRoundedIcon />
              </Button>
            </div>
            <div style={{ overflow: 'scroll' }}>
              {mappedProposals}
            </div>
          </div>
        </div>
        <div onClick={slider === true ? () => { { setSlider(!slider); closeSlider() } } : () => ''} >
          <Title title={`${systemSize / 1000}-${name}-Proposal-v${propVersion}`} />
          <div className='page1'>
            {name ? (
              <>
                <div className='name'>
                  <div className='nameInside' onClick={() => { +view === 1 ? setViewCustomer(!viewCustomer) : closeSlider() }} >
                    <span>{name}</span>
                    <span>{phone}</span>
                    <span>{street}</span>
                    <span>{city}, {state} {zip}</span>
                  </div>
                </div>
              </>
            ) : (
              <div className='loading-box'>
                <CircularProgress size={50} color="inherit" />
              </div>
            )}
          </div>
          <div className='page2'>
            <div>
              <div className='twentyFiveYr'>
                <span>${Math.round((total(years) * 12)).toLocaleString(undefined)}</span>
              </div>
              <div className='barChart'>
                <BarChart years={years} />
              </div>
              <div className='name2'>
                <span>${Math.round(billCalc[1])}</span>
                <span>${(Math.round(billCalc[1]) * 12).toLocaleString(undefined)}</span>
                <span>{increase}%</span>
                <span>${Math.round((total(years) * 12)).toLocaleString(undefined)}</span>
              </div>
            </div>
            <div className='greenCalcs'>
              <div className='greenCalcs1'>
                <span>{gallons().toLocaleString(undefined)}</span>
                <span>{homes().toLocaleString(undefined)}</span>
                <span>{garbages().toLocaleString(undefined)}</span>
              </div>
              <div className='greenCalcs2'>
                {trees().toLocaleString(undefined)}
              </div>
            </div>
          </div>

          <div className='page3'>
            <div className='filler'>
            </div>
          </div>
          <div className='page4'>
            <div className='designWrapper'>
              <div className='originalDesign'>
                {panelAmount > originalPanelAmount ? (
                  <>
                    <span> {originalPanelAmount} Panel Design, plus {panelAmount - originalPanelAmount} panel(s) </span>
                    <span>(Original Design Below)</span>
                  </>
                ) : panelAmount < originalPanelAmount ? (<>
                  <span> {originalPanelAmount} Panel Design, minus {originalPanelAmount - panelAmount} panel(s) </span>
                  <span>(Original Design Below)</span>
                </>
                ) : (
                  <>
                    <span style={{ marginBottom: '1.3rem' }}>  {originalPanelAmount} Panel Design </span>
                  </>
                )}
              </div>
              <div className='design' style={{ backgroundImage: `url(${design})` }}></div>
            </div>
          </div>
          <div className={uType === 'Square Footage' ? 'page5 page5SqFt' : uType === 'Partial 12 Months' ? 'page5 page5PartialUsage' : 'page5'}>
            <div className={uType === 'Square Footage' ? 'systemInfo systemInfoSqFt' : uType === 'Partial 12 Months' ? 'systemInfo systemInfoPartial' : 'systemInfo'}>
              <div className={uType === 'Square Footage' ? 'page5Left page5LeftSqFt' : 'page5Left'}>
                <div className='left1'>
                  <span>{systemSize / 1000} kW</span>
                  <span>{displayProd.toLocaleString(undefined)} kWh </span>
                </div>
                <div className={uType === 'Square Footage' ? 'left2 noDisplay' : 'left2'}>
                  <span className={uType === 'Square Footage' ? ' noDisplay' : ''}>{nest > 0 ? ((nestAmount / totalUsage)).toLocaleString('en-US', { style: 'percent' }) : '-'}</span>
                  {utilityOffset()}
                  <span className={uType === 'Square Footage' ? ' noDisplay' : ''}>{offset}%</span>
                </div>
              </div>
              <div className='nest' >
                <div className={uType === 'Square Footage' ? 'doughnutChart noDisplay' : 'doughnutChart'}>
                  <DoughnutChart
                    utility={utility}
                    totalUsage={totalUsage}
                    propRatio={propRatio}
                    systemSize={systemSize}
                    totalProduction={totalProduction}
                    nestAmount={nestAmount}
                    nest={nest}
                  />
                </div>
              </div>
              <div>
                <div className={uType === 'Square Footage' ? 'right rightSqFt' : 'right'}>
                  <div className={uType === 'Square Footage' ? 'subRight subRightSqFt' : 'subRight'}>
                    <div >
                      <span>{panelAmount} {mod[1]} {mod[3]}</span>
                    </div>
                    <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
                      {view === `1` ? (
                        panelAmount === +maxModCount || proposal.maxOffset && (totalProduction / totalUsage) * 100 >= (+proposal.maxOffset * .97) || +proposal.groundMount === 1 ? <ArrowUpwardRoundedIcon fontSize="large" color='disabled' /> : <ArrowUpwardRoundedIcon fontSize="large" onClick={() => addPanel()} />
                      ) : (
                        <>
                        </>
                      )}
                      {view === `1` ? (
                        panelAmount === 7 || +proposal.groundMount === 1 ? <ArrowDownwardRoundedIcon fontSize="large" color='disabled' /> : <ArrowDownwardRoundedIcon fontSize="large" onClick={() => removePanel()} />
                      ) : (
                        <>
                        </>
                      )}
                    </div>
                    <div>
                      <span>{invType} IQ</span>
                    </div>
                  </div>
                  <div className={uType === 'Square Footage' ? 'lowRight lowRightSqFt' : 'lowRight'}>
                    <span>Enphase Envoy IQ</span>
                  </div>
                </div>
                <div className={uType === 'Square Footage' ? 'productionChart productionChartSqFt' : 'productionChart'}>
                  <OffsetChart
                    uType={uType}
                    usage={usage}
                    production={production}
                    systemSize={systemSize}
                    totalProduction={totalProduction}
                    nestAmount={nestAmount}
                    pRatio={pRatio}
                    currentUsage={currentUsage}
                  />
                </div>
              </div>
            </div>
          </div>
          <div className='page6'>
            <div className='page6Loan'>
              <div className='loanReview'>
                <div className='leftPayments'>
                  <span >{postPayment()}</span>
                  <div className='leftPaymentsBottom'>
                    <div className='font'>
                      <span className='fontTest'>{monthlyPayments()} MONTHLY PAYMENTS IF INCENTIVE<br />
                        INVESTMENT NOT APPLIED TOWARD LOAN:</span>
                      <span>${Math.round(loanA[5] * loanAmount)}</span>
                    </div>
                    {loanA[6] > 0 && loanA[1] === 'Dividend' ? (
                      <>
                        <div className='font'>
                          <span className='fontTest'>MONTHLY PAYMENTS IN MONTHS 1-16<br />
                            PRIOR TO INVESTMENT PAYMENT:</span>
                          <span >${Math.round(loanA[6] * loanAmount)}</span>
                        </div>
                      </>
                    ) : loanA[6] > 0 && loanA[1] === 'Sunlight Int Only' ? (
                      <>
                        <div className='font'>
                          <span className='fontTest'>MONTHLY PAYMENTS IN MONTHS 1-18<br />
                            PRIOR TO INVESTMENT PAYMENT:</span>
                          <span >${Math.round(loanA[6] * loanAmount)}</span>
                        </div>
                      </>
                    ) : (
                      <>
                      </>
                    )}
                  </div>
                </div>
                <div className='financeOptions'>
                  <div className='discounts' >
                    {sameDay === 1 ? (
                      <>
                        <span className='discountFont'>Same Day</span>
                      </>
                    ) : preferredUtility === 1 ? (
                      <>
                        <span className='discountFont'>Preferred Utility Discount</span>
                      </>
                    ) : referral === 1 ? (
                      <span className='discountFont'>Referral</span>
                    ) : utility === 'Portland General Electric (PGE)' || utility === 'Pacific Power' ? (
                      +rebateSF > 0 ? (
                        <>
                          <span className='discountFont'>{oregonLabel}</span>
                        </>
                      ) : (
                        <>
                          <span className='discountFont'>Upfront Rebate</span>
                        </>
                      )
                    ) : (
                      custUtility === 'Austin Energy' && proposal.rebate > 0 ? <span className='discountFont'>Utility Rebate</span> : <span className='discountFont'>Upfront Rebate</span>

                    )}
                  </div>
                  <div className='financeInner'>
                    <span style={{ color: 'rgba(255, 255, 255, 0.927)' }}>${Math.round(systemCost).toLocaleString(undefined)}</span>
                    <span>${Math.round(downPayment).toLocaleString(undefined)}</span>
                    {sameDay === 1 ? (
                      <>
                        <span>${Math.round(sameDayAmount).toLocaleString(undefined)}</span>
                      </>
                    ) : preferredUtility === 1 ? (
                      <>
                        <span>${Math.round(preferredUtilityAmount * systemSize).toLocaleString(undefined)}</span>
                      </>
                    ) : referral === 1 ? (
                      <>
                        <span>${Math.round(referralAmount).toLocaleString(undefined)}</span>
                      </>
                    ) : (
                      <span>${Math.round(rebate).toLocaleString(undefined)}</span>
                    )}
                    <span style={{ color: 'rgba(255, 255, 255, 0.927)' }}>${Math.round(loanAmount).toLocaleString(undefined)}</span>
                    <span>${Math.round((loanAmount + +downPayment - homeEnergyTotal) * loanA[7]).toLocaleString(undefined)}</span>
                    <span>${stateTax.toLocaleString(undefined)}</span>
                    <span style={{ color: 'rgba(255, 255, 255, 0.927)' }}>${Math.round(netCost).toLocaleString(undefined)}</span>
                    <span style={{ color: 'rgba(255, 255, 255, 0.927)' }}>${Math.round(loan1Savings).toLocaleString(undefined)}</span>
                    <span>{loanA[2]} years</span>
                    <span style={{ color: 'rgba(255, 255, 255, 0.927)' }}>${Math.round(loanA[4] * loanAmount)}</span>
                  </div>
                  <div className='financeInner'>
                    <span style={{ color: 'rgba(255, 255, 255, 0.927)' }}>${Math.round(systemCost).toLocaleString(undefined)}</span>
                    <span>${Math.round(downPayment).toLocaleString(undefined)}</span>
                    {sameDay === 1 ? (
                      <>
                        <span>${Math.round(sameDayAmount).toLocaleString(undefined)}</span>
                      </>
                    ) : preferredUtility === 1 ? (
                      <>
                        <span>${Math.round(preferredUtilityAmount * systemSize).toLocaleString(undefined)}</span>
                      </>
                    ) : referral === 1 ? (
                      <>
                        <span>${Math.round(referralAmount).toLocaleString(undefined)}</span>
                      </>
                    ) : (
                      <span>${Math.round(rebate).toLocaleString(undefined)}</span>
                    )}
                    <span style={{ color: 'rgba(255, 255, 255, 0.927)' }}>${Math.round(loanAmount).toLocaleString(undefined)}</span>
                    <span>${Math.round((loanAmount + +downPayment - homeEnergyTotal) * loanB[7]).toLocaleString(undefined)}</span>
                    <span>${stateTax.toLocaleString(undefined)}</span>
                    <span style={{ color: 'rgba(255, 255, 255, 0.927)' }}>${Math.round(netCost).toLocaleString(undefined)}</span>
                    <span style={{ color: 'rgba(255, 255, 255, 0.927)' }}>${Math.round(loan2Savings).toLocaleString(undefined)}</span>
                    <span>{loanB[2]} years</span>
                    <span style={{ color: 'rgba(255, 255, 255, 0.927)' }}>${Math.round(loanB[4] * loanAmount)}</span>
                  </div>
                </div>
              </div>
              <div className='loanSummary'>
                <div className='loanSummaryLeft'>
                  <div className='loanSummaryLeftTop'>
                    <span>${Math.round(systemCost).toLocaleString(undefined)}</span>
                    <div className="loanSummaryLeftRebate">
                      {sameDay === 1 ? (
                        <>
                          <span className='fontTest'>SAME DAY DISCOUNT</span>
                        </>
                      ) : preferredUtility === 1 ? (
                        <>
                          <span className='fontTest'>PREFERRED UTILITY DISCOUNT</span>
                        </>
                      ) : referral === 1 ? (
                        <span className='fontTest'>REFERRAL DISCOUNT</span>
                      )
                        : utility === 'Portland General Electric (PGE)' || utility === 'Pacific Power' ? (
                          +rebateSF > 0 ? (
                            <>
                              <span className='fontTest'>{oregonLabel.toUpperCase()}</span>
                              {/* <span className='fontTest'>ENERGY TRUST INCENTIVE</span> */}
                            </>
                          ) : (
                            <span className='fontTest'>INSTALLER PAID INCENTIVE</span>
                          )
                        ) : (
                          custUtility === 'Austin Energy' && proposal.rebate > 0 ? <span className='fontTest'>UTILITY REBATE</span> : <span className='fontTest'>INSTALLER PAID INCENTIVE</span>
                        )}
                      {sameDay === 1 ? (
                        <>
                          <span>${Math.round(sameDayAmount).toLocaleString(undefined)}</span>
                        </>
                      ) : preferredUtility === 1 ? (
                        <>
                          <span>${Math.round(preferredUtilityAmount * systemSize).toLocaleString(undefined)}</span>
                        </>
                      ) : referral === 1 ? (
                        <>
                          <span>${Math.round(referralAmount).toLocaleString(undefined)}</span>
                        </>
                      ) : (
                        <span>${Math.round(rebate).toLocaleString(undefined)}</span>
                      )}
                    </div>
                    <span>${Math.round(downPayment).toLocaleString(undefined)}</span>
                  </div>
                  <div>
                    <span>${Math.round(loanAmount).toLocaleString(undefined)}</span>
                  </div>
                </div>
                <div className='loanSummaryRight'>
                  <span>${Math.round((loanAmount + +downPayment - homeEnergyTotal) * loanA[7] + stateTax).toLocaleString(undefined)}</span>
                  <span>${Math.round(netCost).toLocaleString(undefined)}</span>
                </div>
                <div className='yearAvgChart'>
                  {loanA ? (
                    <YearAvgChart
                      years={years}
                      totalUsage={totalUsage}
                      postYears={postYears}
                      totalProduction={totalProduction}
                      loan1Bills={loan1Bills}
                      loan2Bills={loan2Bills}
                    />
                  ) : (
                    <>
                    </>
                  )}
                </div>
              </div>
            </div>
            {/* {utility === 'Portland General Electric (PGE)' || utility === 'Pacific Power' ? (
            <div>
              <span className='discountFontc' style={{ marginLeft: '13rem' }}>*Cannot combine with Energy Trust.</span>
            </div>
          ) : (
              <>
              </>
            )} */}
          </div>
          <div className={+loan1Savings < 0 ? 'noDisplay' : 'page7'}>
            <div className="savingsReport">
              <div className='savingsOptions'>
                <div className='optionName'>
                  {/* <span>{loanA ? loanA[1].toUpperCase() : ''} {loanA[2]} YR {loanA[3]}% APR</span> */}
                  <>
                    {view === '1' ? (
                      <>
                        <Button onClick={handleClick1} aria-controls="simple-menu" aria-haspopup="true" style={{ display: 'flex', width: '100%', height: '47px' }}>
                          <span style={{ fontSize: '1.6rem' }}>{loanA[1]} {loanA[2]} yr {loanA[3]}% APR</span>
                        </Button>
                        <Menu
                          onChange={e => setLoanA(e.target.value)}
                          id="long-menu1"
                          anchorEl={anchorLoan12}
                          keepMounted
                          open={Boolean(anchorLoan12)}
                          onClose={handleClose12}
                        // labelWidth={labelWidth}
                        >
                          {mappedLoans}
                        </Menu>
                      </>
                    ) : (
                      <>
                        <Button style={{ display: 'flex', width: '100%', height: '47px', fontSize: '1.6rem' }} >{loanA[1]} {loanA[2]} YR {loanA[3]}% APR</Button>
                      </>
                    )}
                  </>
                </div>
                <div className='optionTerms'>
                  <span >${Math.round(loanA[4] * loanAmount)}</span>
                  <span>{loanA[2]} years</span>
                  <span>${Math.round(loan1Savings).toLocaleString(undefined)}</span>
                </div>
                <div className='postPayment'>
                  <span>${Math.round(loanA[5] * loanAmount)}</span>
                </div>
                <div className='option25'>
                  <span>${Math.round(total(years) * 12).toLocaleString(undefined)}</span>
                  {loanA ? (
                    <span>${Math.round(total(loan1Bills) * 12).toLocaleString(undefined)}</span>
                  ) : (
                    <>
                    </>
                  )}
                  {total(postYears) * 12 <= 0 ? (
                    <span>${Math.round(total(postYears1)).toLocaleString(undefined)}</span>
                  ) : (
                    <span>${Math.round(total(postYears) * 12).toLocaleString(undefined)}</span>
                  )}
                </div>
                <div className='totalSavings'>
                  <span>${Math.round(loan1Savings).toLocaleString(undefined)}</span>
                </div>
              </div>
              <div className='savingsOptions'>
                <div className='optionName'>
                  {/* <span>{loanB[1]} {loanB[2]} years {loanB[3]}</span> */}
                  {view === '1' ? (
                    <>
                      <Button onClick={handleClick22} aria-controls="simple-menu" aria-haspopup="true" style={{ display: 'flex', width: '100%', height: '47px' }}>
                        <span style={{ fontSize: '1.6rem' }}>{loanB[1]} {loanB[2]} yr {loanB[3]}% APR</span>
                      </Button>
                      <Menu
                        // onChange={e => setLoanB(e.target.value)}
                        id="long-menu"
                        anchorEl={anchorLoan22}
                        keepMounted
                        open={Boolean(anchorLoan22)}
                        onClose={handleClose22}
                      // labelWidth={labelWidth}
                      >
                        {mappedLoans2}
                      </Menu>
                    </>
                  ) : (
                    <>
                      <Button style={{ display: 'flex', width: '100%', height: '47px', fontSize: '1.6rem' }} >{loanB[1]} {loanB[2]} YR {loanB[3]}% APR</Button>
                    </>
                  )}
                </div>
                <div className='optionTerms'>
                  <span >${Math.round(loanB[4] * loanAmount)}</span>
                  <span>{loanB[2]} years</span>
                  <span>${Math.round(loan2Savings).toLocaleString(undefined)}</span>
                </div>
                <div className='postPayment'>
                  <span>${Math.round(loanB[5] * loanAmount)}</span>
                </div>
                <div className='option25'>
                  <span>${Math.round(total(years) * 12).toLocaleString(undefined)}</span>
                  <span>${Math.round(total(loan2Bills) * 12).toLocaleString(undefined)}</span>
                  {total(postYears) * 12 <= 0 ? <span>${Math.round(total(postYears1)).toLocaleString(undefined)}</span> : <span>${Math.round(total(postYears) * 12).toLocaleString(undefined)}</span>}
                </div>
                <div className='totalSavings'>
                  <span>${Math.round(loan2Savings).toLocaleString(undefined)}</span>
                </div>
              </div>
            </div>
          </div>
          <div className={custUtility === 'Austin Energy' ? 'page8Austin' : 'page8'}>
            <div>
              <div className='utility'>
                <span>{utility}</span>
                <span>${Math.round(billCalc[1])}</span>
                <span>${(billCalc[1] / billCalc[4]).toFixed(3)}</span>
                <span>{increase}%</span>
              </div>
              <div className='system'>
                <span>{systemSize / 1000} kW</span>
                <span>{nest === 1 || nest > 0 ? Math.round((totalProduction - nestAmount)).toLocaleString(undefined) : Math.round(totalProduction).toLocaleString(undefined)}</span>
                <span>0.5%</span>
              </div>
              <div className='loan'>
                <span>${Math.round(systemCost).toLocaleString(undefined)}</span>
                <span>${Math.round(rebate).toLocaleString(undefined)}</span>
                <span>${Math.round(downPayment).toLocaleString(undefined)}</span>
              </div>
              <div className='options'>
                <div className='option'>
                  <span>Option 1</span>
                  <span>{loanA[3]}%</span>
                  <span>{loanA[2]} years</span>
                  <span>${Math.round((loanAmount - homeEnergyTotal) * loanA[7]).toLocaleString(undefined)}</span>
                </div>
                <div className='option'>
                  <span>Option 2</span>
                  <span>{loanB[3]}%</span>
                  <span>{loanB[2]} years</span>
                  <span>${Math.round((loanAmount - homeEnergyTotal) * loanB[7]).toLocaleString(undefined)}</span>
                </div>
              </div>
            </div>
          </div>
          <div className="bottomRebate">
            {utility === 'Portland General Electric (PGE)' || utility === 'Pacific Power' ? (
              +rebateSF > 0 ? <span className='optionRebate'>{oregonLabel}</span> : <span className='optionRebate'>Installer Paid Incentive</span>
            ) : (
              <>
                {custUtility === 'Austin Energy' && proposal.rebate > 0 ? <span className="optionRebate">Utility Rebate</span> : <span className="optionRebate">Installer Paid Incentive</span>}
              </>
            )}
          </div>
          {+battery10 > 0 ? (
            <>
              <div className='page9'>
                <div className='filler'>
                </div>
              </div>
            </>
          ) : (
            <>
            </>
          )}
        </div>
      </div>
    </>
  )
}
export default ProposalView